webpackJsonp([1],{

/***/ "+NoH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+hDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_scroll_scroll__ = __webpack_require__("mnFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_goodsItem_goodsItem__ = __webpack_require__("g5XB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchIndex',
  data: function data() {
    return {
      keyWord: '',
      curPage: 1,
      pageSize: 10,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: true,
      listenScroll: true,
      probeType: 3
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this.keyWord = this.$route.params.keyword;
    this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
    this.probeType = 3;
    this.listenScroll = true;
    this.touch = {};

    this._getData(true);
  },

  methods: {
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },
    scroll: function scroll(scrollPos, maxY) {
      if (scrollPos.y > 30) {
        this.pullDownMsg = '释放刷新';
      }
      if (scrollPos.y <= maxY - 40 && this.hasMore) {
        this.pullUpMsg = '释放加载更多';
      }
    },
    scrollToEnd: function scrollToEnd() {
      if (this.hasMore) {
        this._getData();
      }
    },
    scrollToTop: function scrollToTop() {
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
    },
    toDetail: function toDetail(item) {
      this.$router.push({ path: '/GoodsDetail/' + item.id });
    },
    searchSub: function searchSub(keyWord) {
      this.keyWord = keyWord;
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
      this.$refs.listview.scrollTo(0, 0);
    },
    _getData: function _getData(clear) {
      var _this = this;

      if (!this.keyWord) {
        this.$toast('请输入关键字');
        return;
      }
      this.$cHttp.post('products/search', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        keywords: this.keyWord ? this.keyWord : '',
        page_pernum: this.pageSize,
        current_page: this.curPage
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          if (clear) {
            _this.data = res.data.rows;
          } else {
            _this.data = _this.data.concat(res.data.rows);
          }
          if (_this.curPage + 1 > res.data.total_page) {
            _this.hasMore = false;
            _this.pullUpMsg = '没有更多数据了';
          } else {
            _this.curPage++;
          }
          if (res.data.rows.length < 1) {
            _this.$toast('暂无数据');
          }
        } else {
          _this.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_0_basic_scroll_scroll__["a" /* default */], GoodsItem: __WEBPACK_IMPORTED_MODULE_1_basic_goodsItem_goodsItem__["a" /* default */], SearchBlock: __WEBPACK_IMPORTED_MODULE_2_basic_searchBlock_searchBlock__["a" /* default */]
  }
});

/***/ }),

/***/ "+jX/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+nNt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/7yX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAC4ElEQVRoQ+1Z4VUWMRDcqUCpQKlArQCoQK1AqUCsQKkAqECsQDsQK1ArECoQK1je3EvuhZBcdnPwHejlz/E9csnObnZmNwd54AMP3H5ZASwdwX8vAqq6KyIfjJ59D+An56rqsYg8M77XO417HQK4jAtci4CqPheRH47V9wCcBQB87jje7Z16BmCvBuBURN44Vl4CAM3bBnDOP/IIeL34UUROROSpiHwJTwf+7qmj4+YC6LZg5osrgJkOnP16NQJfReSlY/l9AEx80igp7q5pNJpWBUAaJZ9b6XApFioDiPBUlazy1iBo9xNABoTHqnY0rABG3g7O+V04pp8B0GnDUNVvIsKqoDSmI5C+oaqPRYT6UAJhBZAbV8q1dC0C+TSRi3YAwRsEwSR9ki3qEbIXSd1Ez9LDcfwCwPyL3meEeIxrwwcggMg3dZDVMPVaDaOqLAWiQ1I2OxCRo8bifgABhLfUyO0oHZO/ABhhnns+6f3h961GIGzwKtQ8Xu/H+XkUWBYfA+BRJAA+LaV8dwTomT+J9T1C9hoAkzgafMrKcoKdSs7qAxA2TRXXykKpEecAtnOrVNVTys8CkOaBGQAAc/uqqq1c+78BpBxtjkAQw5T3SZeR9ylcaSdITZhior4IFBLNI2Tpsf8OYCwTHOwT1+gG0JL4Se5O/nkZVTkQA1U3Vd7WDUc3gJbEVwEsnsSqapH4qQgMYhXGRWyEQgR4nNIehJG+vVoo3Bex+MoTq0fIaPPmcmDCeBriYaHNJ7GqktqYUDVK6wVANR9pNHR/YzNjKLSaLSUN54K1jugGnRnU02CXeUq1qafBvGFrlbP3FkCrBsld1CtkZldXJq43c3M9OPf9NQLRg71CdmcRIOe/c6zeqwOOLYpTt+Jnpvz7AOmT1x2PjDssAeAEwCiCN9q8cLXBCa2mghgPso984+WU0QGeaVRv3moMFwJxmPtUz06bnLsC2KS3S3utEVg6AlcMkrBA1HULeAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "/FEU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADu0lEQVRoQ+2Z3VHbQBDHd80jPDgVRLwBdzOBCgIVBCoIVABUEFNBoII4FcQdxHQAM3fAW5QKYg8+niQ2s56z5yzr4yTLsslELzD26fT/7a5299YIb/zCN64f/j2AIAjam5ubXxDxFADaNXioNxqNzsIwHEz22tvbu355eem4n1V9zpwHePNWq3VedcO0+4jou9aaDTK+pJRERHfGmKNFIeYApJR/arK8y3KrlDp0Aez/PaXUySLGSgOgRTbMuDcLAIioq7U+q/rMlQOw8EUg1gJgEYiVAAghQkR8nwybKp5YCUBepiOiS631te87sRIAm0qnWckVG0VR+PT0FK4VABGFWuttX1Fl1jXlAdbUA4C7LHGI2H9+fr4vW9iaBPAx7MC+A12fxbxm3QBY00Ap9e4tA4BSyrtLXkcPLA1gmPcS+rrcVt0grZBN9qjdA0T02xizXzZD5EEJIXqI+CltTe0AAHCllOqUsXLRWiklF7KfjQC8vr7ePDw8XBSJKvP97u7u8cbGxo9GADi1AcCJUqpfRmTW2p2dncCK5yRyh4jj1oGI9gEg0FrzX6+r8SzE7xMAdOI47pfpeTIrePILPq96oZdfNCSiTlqnaT3S1lpnthorBSCiewA4nQjkycfW1tY5ER0j4ky4cOPHfVMcxzc+Hlp6CLF4Y8zhJAVLKTmb8dSjcGTDBxxjzGVe+l42wDCKon22pLX6NwA4LhN9PH4BgLOs8CoDcBVFUdfHrWkC8wpXEVDeDMkLIDmYKnpg8nshxAUifi17X2J96gzJC2CRSmxD55dPzKcA3gLAR+fzo2Qt8gXoK6WOqlhQCHGKiBz7ZS5OuYcc9+4AIC0SfAH44VyFvSuxUuqKb0rGvk2p7ZxudCo+5f65w04ZgDIWnI4S3RkQV2GtdWAn4H1E/JDYNCm+i4if3TVEdOBmpKUDJCr7YDQabXNeT4EoFG9BZt6DpgG4YZuO1R2IYBLzNmzmLJ/1Ii8LYHosFEJwtzkTKikQ3IGO+yAhRJ54NkAjIQRRFG1z0csSlFacisQDwFApNdOCLM0DRMTlv5t3cHEhPMSz9Wd+6WGPLRNgOk6UUnL6dQuSm1h4mMXT6sJDTDJ8UgF8LOGbT+M4Pnl8fOzlnX9998o61s55wJZ+nmNmWcz3mezy0BhzwGmzYkUePyvZkrsCvCdg3qpzFlaByBOfGkJ1CM3bw4YTH2qKPMyDtOuicU6jHnDBODu1Wi0+UgYTGHvg53rQN8Z0fQZpKwOoy9P/AeqyZNV9/gJTZ6FPkzgJIQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "/UM/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0nQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1aI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"server-outBox"},[_c('h3',{staticClass:"server-title"},[_vm._v("网站使用条款")]),_vm._v(" "),_c('div',{staticClass:"server-content"},[_c('p',[_vm._v("本协议是您与罗恩网站（简称;本站;，网址：www.rhawn.cn）所有者（以下简称为;罗恩;）之间就罗恩网站服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击;同意并继续;按钮后，本协议即构成对双方有约束力的法律文件。")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第1条 本站服务条款的确认和接纳")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("1.1")]),_vm._v("本站的各项电子服务的所有权和运作权归罗恩所有。用户同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("1.2")]),_vm._v("用户点击同意本协议的，即视为用户确认自己具有享受本站服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("1.3")]),_vm._v("如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用本站。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("1.4")]),_vm._v("罗恩保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。\n        ")]),_c('p',[_c('b',[_vm._v("第2条 本站服务")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("2.1")]),_vm._v("罗恩通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及本站规定的情况下，方有权使用本站的相关服务。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("2.2")]),_vm._v("用户必须自行准备如下设备和承担如下开支：（1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；（2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。\n\t\t\t\t")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第3条 用户信息")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("3.1")]),_vm._v("用户应自行诚信向本站提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且罗恩保留终止用户使用罗恩各项服务的权利。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("3.2")]),_vm._v("用户在本站进行浏览、下单购物等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("3.3")]),_vm._v("用户注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("3.4用户同意，罗恩拥有通过邮件、短信电话等形式，向在本站注册、购物用户、收货人发送订单信息、促销活动等告知信息的权利。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("3.5用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("3.6用户同意，罗恩有权使用用户的注册信息、用户名、密码等信息，登录进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第4条 用户依法言行义务")]),_c('br'),_vm._v("\n          本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务："),_c('br'),_vm._v(" "),_c('b',[_vm._v("（1）")]),_vm._v("不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（2）")]),_vm._v("从中国大陆向境外传输资料信息时必须符合中国有关法规；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（3）")]),_vm._v("不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（4）")]),_vm._v("不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（5）")]),_vm._v("不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（6）")]),_vm._v("不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（7）")]),_vm._v("不得教唆他人从事本条所禁止的行为；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（8）")]),_vm._v("不得利用在本站注册的账户进行牟利性经营活动；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（9）")]),_vm._v("不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；"),_c('br'),_vm._v("\n          用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("若用户未遵守以上规定的，本站有权作出独立判断并采取暂停或关闭用户帐号等措施。")]),_vm._v("用户须对自己在网上的言论和行为承担法律责任。\n\t  \t\t")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第5条 商品信息")]),_c('br'),_vm._v("\n          本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；罗恩欢迎纠错，并会视情况给予纠错者一定的奖励。"),_c('br'),_vm._v("\n          为表述便利，商品和服务简称为;商品;或;货物。"),_c('br')]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第6条 订单")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("6.1")]),_vm._v("在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("6.2除法律另有强制性规定外，双方约定如下：本站上销售方展示的商品和价格等信息仅仅是交易信息的发布，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售方发出的交易诉求；销售方收到您的订单信息后，只有在销售方将您在订单中订购的商品从仓库实际直接向您发出时（ 以商品出库为标志），方视为您与销售方之间就实际直接向您发出的商品建立了交易关系；如果您在一份订单里订购了多种商品并且销售方只给您发出了部分商品时，您与销售方之间仅就实际直接向您发出的商品建立了交易关系；只有在销售方实际直接向您发出了订单中订购的其他商品时，您和销售方之间就订单中该其他已实际直接向您发出的商品才成立交易关系。您可以随时登录您在本站注册的账户，查询您的订单状态。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("6.3由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品，发生缺货，您有权取消订单。")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第7条 配送")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("7.1")]),_vm._v("销售方将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("7.2")]),_vm._v("因如下情况造成订单延迟或无法配送等，销售方不承担延迟配送的责任："),_c('br'),_vm._v(" "),_c('b',[_vm._v("（1）")]),_vm._v("用户提供的信息错误、地址不详细等原因导致的；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（2）")]),_vm._v("货物送达后无人签收，导致无法配送或延迟配送的；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（3）")]),_vm._v("情势变更因素导致的；"),_c('br'),_vm._v(" "),_c('b',[_vm._v("（4）")]),_vm._v("不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。\n        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第8条 所有权及知识产权条款")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("8.1用户一旦接受本协议，即表明该用户主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给罗恩所有，用户同意罗恩有权就任何主体侵权而单独提起诉讼。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("8.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在罗恩网站上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("8.3用户同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("8.4罗恩是本站的制作者,拥有此网站内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知用户。在法律允许的最大限度范围内，罗恩对本协议及本站内容拥有解释权。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("8.5除法律另有强制性规定外，未经罗恩明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，罗恩有权追究其法律责任。")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("8.6")]),_vm._v("本站所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是罗恩或其内容提供者的财产，受中国和国际版权法的保护。本站上所有内容的汇编是罗恩的排他财产，受中国和国际版权法的保护。本站上所有软件都是罗恩或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。\n\t  \t\t")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第9条 责任限制及不承诺担保"),_c('br'),_vm._v("\n          除非另有明确的书面说明,本站及其所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在;按现状;和;按现有;的基础上提供的。"),_c('br'),_vm._v("\n          除非另有明确的书面说明,罗恩不对本站的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。"),_c('br'),_vm._v("\n          罗恩不担保本站所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。"),_c('br'),_vm._v("\n          如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，罗恩会合理地尽力协助处理善后事宜。")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第10条 协议更新及用户关注义务")]),_c('br'),_vm._v("\n          根据国家法律法规变化及网站运营需要，罗恩有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议； "),_c('br'),_vm._v(" "),_c('b',[_c('i',[_vm._v("用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受罗恩网站依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。罗恩建议您在使用本站之前阅读本协议及本站的公告。")])]),_vm._v(" 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。\n\t  \t\t")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第11条 法律管辖和适用")]),_c('br'),_vm._v("\n          本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。 如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。\n        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("第12条 其他")]),_vm._v(" "),_c('b',[_vm._v("12.1")]),_vm._v("罗恩网站所有者是指在政府部门依法许可或备案的罗恩网站经营主体。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("12.2")]),_vm._v("罗恩尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本站欢迎用户和社会各界提出意见和建议，罗恩将虚心接受并适时修改本协议及本站上的各类规则。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("12.3")]),_vm._v("本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。"),_c('br'),_vm._v(" "),_c('b',[_vm._v("12.4")]),_vm._v("您点击本协议下方的;同意并继续;按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。\n        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1tiE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2QV3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer-block"},[_c('ul',{staticClass:"footer-menus"},[_c('li',{staticClass:"footer-menu-item goodsSearch",class:{'active':_vm.$store.state.pageBelong=='GoodsSearch'},on:{"click":function($event){_vm.pageChange('/SearchIndex')}}},[_vm._v("产品查询")]),_vm._v(" "),_c('li',{staticClass:"footer-menu-item shopBag",class:{'active':_vm.$store.state.pageBelong=='ShopBag'},attrs:{"id":"shopCart"},on:{"click":function($event){_vm.pageChange('/ShopBag')}}},[_vm._v("购物车"),(_vm.$store.state.shopCount)?_c('i',{staticClass:"goods-num"},[_vm._v(_vm._s(_vm.$store.state.shopCount))]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"footer-menu-item orderList",class:{'active':_vm.$store.state.pageBelong=='OrderList'},on:{"click":function($event){_vm.pageChange('/OrderList')}}},[_vm._v("订单")]),_vm._v(" "),_c('li',{staticClass:"footer-menu-item userCenter",class:{'active':_vm.$store.state.pageBelong=='UserCenter'},on:{"click":function($event){_vm.pageChange('/UserCenter')}}},[_vm._v("个人中心")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2f7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_packageDetail_vue__ = __webpack_require__("m5QD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e626e0d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_packageDetail_vue__ = __webpack_require__("xeyQ");
function injectStyle (ssrContext) {
  __webpack_require__("r6k3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e626e0d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_packageDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e626e0d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_packageDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "34+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3UAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'searchBlock',
	data: function data() {
		return {
			keyWord: ''
		};
	},

	methods: {
		searchSub: function searchSub() {
			this.$emit('searchSub', this.keyWord);
		},
		setKeyword: function setKeyword(keyword) {
			this.keyWord = keyword;
		}
	}
});

/***/ }),

/***/ "44/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "58y8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
		name: 'goodsDetail',
		data: function data() {
				return {
						selectedCount: 1,
						curGoodsIndex: 0,
						goodsDetailInfo: {}
				};
		},

		computed: {
				totalPrice: function totalPrice() {
						if (this.goodsDetailInfo.price) {
								var curGoods = this.goodsDetailInfo.price[this.curGoodsIndex];
								var curPrice = curGoods.price ? curGoods.price : curGoods.market_price;
								return curPrice * this.selectedCount;
						} else {
								return 0;
						}
				}
		},
		mounted: function mounted() {
				if (this.$route.meta && this.$route.meta.pageBelong) {
						this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
				}
				this.getDetail();
		},

		methods: {
				searchSub: function searchSub(keyWord) {
						this.$router.push({ path: '/GoodsList/' + keyWord });
				},
				selecteGoodsSize: function selecteGoodsSize(index) {
						this.curGoodsIndex = index;
						this.selectedCount = 1;
				},
				minusNum: function minusNum() {
						if (this.selectedCount == 1) return;
						this.selectedCount = this.selectedCount - 1;
				},
				addNum: function addNum(maxNum) {
						if (this.selectedCount == maxNum) return;
						this.selectedCount = this.selectedCount + 1;
				},
				changeNum: function changeNum(maxNum) {
						if (this.selectedCount < 1) {
								this.selectedCount = 1;
						} else if (this.selectedCount > maxNum) {
								this.selectedCount = maxNum;
						}
				},
				addToShopbag: function addToShopbag() {
						var _this = this;

						var that = this;
						var tempCount = this.$store.state.shopCount;
						if (!this.goodsDetailInfo.price || !this.goodsDetailInfo.price[this.curGoodsIndex]) {
								this.$toast('请选择货号！');
								return;
						}
						if (!this.$store.state.userInfo.user_id) {
								//先登录
								this.$router.push('/Login?backRoute=' + this.$route.path);
								return;
						}
						//加入购物车
						this.$cHttp.post('shopcart/add', {
								partner: this.$systemConfig.partner,
								apikey: this.$systemConfig.apikey,
								user_id: this.$store.state.userInfo.user_id,
								pid: this.goodsDetailInfo.price[this.curGoodsIndex].pid,
								num: this.selectedCount
						}).then(function (res) {
								if (res.status && res.status == 1) {
										console.log(res);
										tempCount = res.data.total_num;
										that.$store.commit('setShopCount', tempCount);
								} else {
										_this.$toast(res.error_msg);
								}
						}).catch(function (msg) {
								_this.$toast(msg);
						});
						// 抛物线运动
						var eleFlyElement = document.querySelector("#flyItem");
						var eleShopCart = document.querySelector("#shopCart");
						var myParabola = funParabola(eleFlyElement, eleShopCart, {
								speed: 80, //抛物线速度
								curvature: 0.0068, //控制抛物线弧度
								complete: function complete() {
										eleFlyElement.style.visibility = "hidden";
										that.$store.commit('setShopCount', tempCount);
								}
						});
						var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft || 0,
						    scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
						eleFlyElement.style.left = event.clientX + scrollLeft + "px";
						eleFlyElement.style.top = event.clientY + scrollTop + "px";
						eleFlyElement.style.visibility = "visible";
						// 需要重定位
						myParabola.position().move();
				},
				getDetail: function getDetail() {
						var _this2 = this;

						this.$cHttp.post('products/price', {
								partner: this.$systemConfig.partner,
								apikey: this.$systemConfig.apikey,
								id: this.$route.params.goodsId
						}).then(function (res) {
								console.log(res);
								if (res.status && res.status == 1) {
										_this2.goodsDetailInfo = res.data;
										console.log(_this2.goodsDetailInfo);
								} else {
										_this2.$toast('暂无数据');
								}
						}).catch(function (msg) {
								_this2.$toast(msg);
						});
				}
		},
		components: {
				SearchBlock: __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__["a" /* default */]
		}
});

/***/ }),

/***/ "5Si1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5zCw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__("txGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42444d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__("SqtP");
function injectStyle (ssrContext) {
  __webpack_require__("Tdg0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42444d64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42444d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6jeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_checkItem_checkItem__ = __webpack_require__("VDv/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_numberSelector_numberSelector__ = __webpack_require__("B9az");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchIndex',
  data: function data() {
    return {};
  },

  props: {
    goodsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    selecteable: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    hasBuyBtn: {
      type: Boolean,
      default: false
    },
    isDetailItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    selectItem: function selectItem() {
      this.$emit('selectItem', this.index);
    },
    changeNum: function changeNum(num) {
      this.$emit('changeItemNum', this.index, num);
    },
    putItemNum: function putItemNum() {
      this.$emit('putItemNum', this.index, this.goodsData.selectedNum);
    }
  },
  components: {
    CheckItem: __WEBPACK_IMPORTED_MODULE_0_basic_checkItem_checkItem__["a" /* default */], NumberSelector: __WEBPACK_IMPORTED_MODULE_1_basic_numberSelector_numberSelector__["a" /* default */]
  }
});

/***/ }),

/***/ "72kJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__ = __webpack_require__("oBeN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editInvocie',
  data: function data() {
    return {
      invoiceInfo: {
        ci_addr: "",
        ci_bank: "",
        ci_bknum: "",
        ci_id: "",
        ci_if_default: "1",
        ci_phone: "",
        ci_title: this.$store.state.userInfo.cus_company,
        ci_type: "1",
        ci_vatno: ""
      },
      isNew: false,
      invoiceType: 'common'
    };
  },
  mounted: function mounted() {
    //获取数据
    if (this.$route.query.invoiceId) {
      this.getDetail();
    } else {
      this.isNew = true;
    }
    //获取焦点时移到页面可见区域
    $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
      var dom = e.target;
      setTimeout(function () {
        dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
      }, 200);
    });
  },

  methods: {
    setInvoiceType: function setInvoiceType(type) {
      if (this.invoiceType != type) {
        this.invoiceInfo.ci_type = type;
        this.$nextTick(function () {
          //获取焦点时移到页面可见区域
          $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
            var dom = e.target;
            setTimeout(function () {
              dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
            }, 200);
          });
        });
      }
    },
    deleteInvocie: function deleteInvocie() {
      var that = this;
      this.$messagebox.confirm('确定删除这条数据？', '温馨提示', { callback: function callback(type) {
          if (type == 'confirm') {
            that.$cHttp.post('cusinvoice/delete', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              ci_id: that.$route.query.invoiceId
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that.$router.go(-1);
              } else {
                that.$toast('删除失败');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    saveInvocie: function saveInvocie() {
      var _this = this;

      if (this.$route.query.invoiceId) {
        this.$cHttp.post('cusinvoice/edit', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey,
          user_id: this.$store.state.userInfo.user_id
        }, this.invoiceInfo)).then(function (res) {
          console.log(res);
          if (res.status && res.status == 1) {
            if (_this.$route.query.isSubSelect == 1) {
              _this.$router.go(-2);
              _this.$store.commit('setSelectedInvoiceData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.invoiceInfo));
            } else {
              _this.$router.go(-1);
            }
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      } else {
        this.$cHttp.post('cusinvoice/add', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey,
          user_id: this.$store.state.userInfo.user_id
        }, this.invoiceInfo)).then(function (res) {
          console.log(res);
          if (res.status && res.status == 1) {
            if (_this.$route.query.isSubSelect == 1) {
              _this.$router.go(-2);
              _this.$store.commit('setSelectedInvoiceData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.invoiceInfo));
            } else {
              _this.$router.go(-1);
            }
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      }
    },
    setDefault: function setDefault() {
      this.invoiceInfo.ci_if_default = this.invoiceInfo.ci_if_default == '1' ? '0' : '1';
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.$cHttp.post('cusinvoice/detail', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        ci_id: this.$route.query.invoiceId
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this2.invoiceInfo = res.data;
        } else {
          _this2.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this2.$toast(msg);
      });
    }
  },
  components: {
    AddrSelector: __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__["a" /* default */]
  }
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.1b235d8.png";

/***/ }),

/***/ "7btx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true}},[_c('ul',{staticClass:"query-list"},[_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item",on:{"click":function($event){_vm.selectAddrItem(item)}}},[(_vm.$route.params.isSelect=='true')?_c('i',{staticClass:"mint-checkbox-core",class:{'checked':item.isSelected}}):_vm._e(),_vm._v(" "),_c('div',[_c('h3',{staticClass:"addr-user"},[_c('label',{staticClass:"name"},[_vm._v(_vm._s(item.cia_name))]),_c('span',{staticClass:"telNum"},[_vm._v(_vm._s(item.cia_mobile))])]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.cia_province))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.cia_city))]),_vm._v(" "),_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.cia_county))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.cia_street))])]),_vm._v(" "),_c('div',{staticClass:"opr-bar"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.params.isSelect!='true'),expression:"$route.params.isSelect!='true'"}],staticClass:"set-default-group",class:{'active':item.cia_if_default==1},on:{"click":function($event){$event.stopPropagation();_vm.setDefault(item)}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':item.cia_if_default==1}}),_vm._v("\n\t\t        \t\t\t"+_vm._s(item.cia_if_default==1?'默认地址':'设为默认地址'))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.params.isSelect=='true'),expression:"$route.params.isSelect=='true'"}],staticClass:"set-default-group",class:{'active':item.cia_if_default==1}},[_vm._v("\n\t\t        \t\t\t"+_vm._s(item.cia_if_default==1?'默认地址':'')+"\n\t\t        \t\t")]),_vm._v(" "),_c('p',{staticClass:"opr-btns"},[_c('a',{staticClass:"opr-btn edit",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.stopPropagation();_vm.editAddr(item)}}}),_vm._v(" "),_c('a',{staticClass:"opr-btn delete",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.stopPropagation();_vm.deleteAddr(item)}}})])])])])}),_vm._v(" "),_c('div',{staticClass:"add-group",staticStyle:{"padding":".2rem"}},[_c('mt-button',{attrs:{"size":"large","type":"danger"},on:{"click":_vm.newAddr}},[_vm._v("新增")])],1)],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "84YD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceAddrList_vue__ = __webpack_require__("JRlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c48c9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceAddrList_vue__ = __webpack_require__("7btx");
function injectStyle (ssrContext) {
  __webpack_require__("G+WG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58c48c9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceAddrList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c48c9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceAddrList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "87jZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAddr_vue__ = __webpack_require__("VRac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a0571f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editAddr_vue__ = __webpack_require__("wdrl");
function injectStyle (ssrContext) {
  __webpack_require__("It2H")
  __webpack_require__("mlVE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a0571f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAddr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a0571f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editAddr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "97Sy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9az":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_numberSelector_vue__ = __webpack_require__("OHuU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc261e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_numberSelector_vue__ = __webpack_require__("CEWJ");
function injectStyle (ssrContext) {
  __webpack_require__("+jX/")
  __webpack_require__("fcOn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bc261e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_numberSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc261e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_numberSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BSvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true},on:{"scroll":_vm.scroll,"scrollToEnd":_vm.scrollToEnd,"scrollToTop":_vm.scrollToTop}},[_c('ul',{staticClass:"query-list"},[_c('div',{staticClass:"pullDown"},[_vm._v(_vm._s(_vm.pullDownMsg))]),_vm._v(" "),(_vm.data.length<1)?_c('p',{staticClass:"empty-list"},[_vm._v("暂无数据")]):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item"},[_c('a',{staticClass:"order-item-mask",attrs:{"href":"javascript:void(0)"}}),_vm._v(" "),_c('h3',{staticClass:"list-item-title"},[_c('span',{class:{'minus':item.prepaylog_amount<0}},[_vm._v(_vm._s(item.prepaylog_amount))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(item.prepaylog_time))])]),_vm._v(" "),_c('div',{staticClass:"list-item-orderContent"},[_vm._v("\n            "+_vm._s(item.prepaylog_note)+"\n          ")])])}),_vm._v(" "),_c('div',{staticClass:"pullUp"},[_vm._v(_vm._s(_vm.pullUpMsg))])],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BnjG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BphF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('form',{staticClass:"login-form",attrs:{"name":"loginForm","action":"javascript:void(0);"}},[_c('img',{staticClass:"user-avatar",attrs:{"src":__webpack_require__("l23d")}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":"请输入登录邮箱"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-input password",attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"form-btn",domProps:{"innerHTML":_vm._s(_vm.login_text)},on:{"click":_vm.loginSub}},[_vm._v(_vm._s(_vm.login_text))]),_vm._v(" "),_c('p',{staticClass:"form-link"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.forgetPW}},[_vm._v("忘记密码")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toRegister}},[_vm._v("立即注册")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CEWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-group"},[_c('div',{staticClass:"minus-btn",class:{'disabled':_vm.selectedCount==_vm.minNum},on:{"click":function($event){$event.stopPropagation();_vm.minusNum($event)}}},[_vm._v("-")]),_vm._v(" "),_c('label',{on:{"click":function($event){$event.stopPropagation();}}},[_c('mt-field',{attrs:{"disableClear":true,"placeholder":"","type":"number"},on:{"change":function($event){_vm.changeNum(_vm.maxNum)}},model:{value:(_vm.selectedCount),callback:function ($$v) {_vm.selectedCount=$$v},expression:"selectedCount"}})],1),_vm._v(" "),_c('div',{staticClass:"add-btn",class:{'disabled':_vm.selectedCount>=_vm.maxNum},on:{"click":function($event){$event.stopPropagation();_vm.addNum(_vm.maxNum)}}},[_vm._v("+")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CNfH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderList_vue__ = __webpack_require__("sYOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9bd204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderList_vue__ = __webpack_require__("Ob3p");
function injectStyle (ssrContext) {
  __webpack_require__("SaeF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c9bd204"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9bd204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CWQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'panyInfo',
  data: function data() {
    return {
      orderNum: ''
    };
  },

  computed: {
    canPrePay: function canPrePay() {
      return this.$store.state.subOrderInfo.so_total < this.$store.state.subOrderInfo.cus_prepay;
    }
  },
  methods: {
    selectPayType: function selectPayType(type) {
      var _this = this;

      if (type == 'wechat') {
        this.$messagebox.alert('温馨提示', '请至罗恩微信公众号在线商城支付！');
      } else if (type == 'offline') {
        this.$toast('线下支付');
        this.$router.replace({ path: '/OrderList' });
      } else if (type == 'prepay') {
        if (this.$store.state.subOrderInfo.so_total > this.$store.state.subOrderInfo.cus_prepay) {
          return;
        }
        this.$cHttp.post('orders/prepay', {
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey,
          user_id: this.$store.state.userInfo.user_id,
          so_id: this.$store.state.subOrderInfo.so_id
        }).then(function (res) {
          console.log(res);
          if (res.status && res.status == 1) {
            _this.$toast('支付成功');
            //更新预存款
            _this.$store.commit('setSubOrderInfo', {
              cus_prepay: _this.$store.state.subOrderInfo.cus_prepay - _this.$store.state.subOrderInfo.so_total,
              so_no: '',
              so_id: '',
              so_total: 0,
              so_ci_method: ''
            });
            _this.$router.replace({ path: '/OrderList' });
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      }
    }
  },
  components: {}
});

/***/ }),

/***/ "CcXR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DDRM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADFklEQVRoQ9VZ23UUMQzVrYCkAkgFQAVkK4BUQLYDqICkAkIFJBWwVEBSAVABoQJIBeLcOfacidczlryznsU/+7EaWVdvyZD//GBJ+VX1Fe8HcFcrxyIAVPVURL6IyFEQ/IeInAG49wLpAKjqMxGhNvibnttdNJQyU9VzEfmcueeviKwAEIz5QFVfiMi3gTZyH5MpmfOS6jMhfOTpBkEA1yLy1iDVewBXBrosiUH4KhAeAHcA6Lvu4xDeDYIAxnxyS1AA7qD38E8uNLlTDGKrGx174mAH4c2W6DUaMtEwC9EyaWwwkG/dPrTHD0ZdIuRqZqfhYRBv9iiPmXVM7VMAWGT+mDm2J2TRW00GpaqS6Gl72cw33pQA0F1em9m1JywCuBCRD+3lMt+4LlngTWi6zBwbEx6XADCt/moslPW6GwDnxcqqqqyIT6xcG9Kx/d5YALBwdYPHAZ0HAN0sYQFwiIHcuY8VgLnZa2ihzn2sADjwfG8oXOmq3n1MAEikqlri2vD/TwDexfuKMRAAHFIgvxzOzVYA1nlh34b4DeDR4sEKgCb7uG/pDPzXAKjM/lgBcBZOZwPDfbOS/BSR03QiNAFYOJC5teNa5yI3znoApLPBPYCTWXVcwcwDYGs2qNlSVMg4+YkHQK6lWHzI9wDIBXJf0ufWrJWfB0BuyGdcuDfKVuECHQOYzVt26WsGEDIRmTx3CjAHOTfkqxwjL4DFOtOxhOECEKywRFvxFQDn863jBhBA0BK5x5A53CXlwZH2emwnWwUg3hD2qUfeV5U5UVYBUFWak81dtAK1dAXgska48ErE/VN0E2Y2ar3Izw0gCM8HutzZADjzgAjCj018BLGe4lcDgHuiKf93VWdV3YmfC8DIyj1V0KORb0p7Be3HT/sNxM5ZyAhgNOWlAhj5Tb7NeS1geTMwv2aGLFZaXV4CYCOZPS4AhkL2wPhwvqOVVvgnUy/4NQBoBV6arhspPEc+10u7qpIftx65HmtrBk7N4AYwKGKsxmyxmZEIaLRaWtKqqnJxEOsAlcC6Uux0qwFYhGpB8w9uTEAB5cdOawAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Dea0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.goodsDetailInfo.code)?_c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"page-center-block"},[_c('img',{staticClass:"goods-detail-img",attrs:{"src":_vm.goodsDetailInfo.img_url}}),_vm._v(" "),_c('section',{staticClass:"goods-attr-block"},[_c('h3',{staticClass:"goods-name"},[_vm._v(_vm._s(_vm.goodsDetailInfo.cn_name))]),_vm._v(" "),_c('p',{staticClass:"goods-attr"},[_vm._v(_vm._s(_vm.goodsDetailInfo.en_name))]),_vm._v(" "),(_vm.goodsDetailInfo.price&&_vm.goodsDetailInfo.price.length>1)?_c('p',{staticClass:"goods-attr red"},[_vm._v("￥"+_vm._s(_vm.goodsDetailInfo.price[0].price)+"-￥"+_vm._s(_vm.goodsDetailInfo.price[1].price))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"goods-attr"},[_vm._v("产品项目编号："+_vm._s(_vm.goodsDetailInfo.code))]),_vm._v(" "),_c('p',{staticClass:"goods-attr blue"},[_vm._v("CAS号："+_vm._s(_vm.goodsDetailInfo.cas))]),_vm._v(" "),_c('p',{staticClass:"goods-attr blue"},[_vm._v("浓度级别："+_vm._s(_vm.goodsDetailInfo.level))]),_vm._v(" "),_c('p',[(_vm.goodsDetailInfo.if_explode)?_c('label',{staticClass:"goods-warning"},[_c('span',[_vm._v("易制爆")])]):_vm._e(),_vm._v(" "),(_vm.goodsDetailInfo.if_drag)?_c('label',{staticClass:"goods-warning"},[_c('span',[_vm._v("易制毒")])]):_vm._e()])]),_vm._v(" "),_c('section',{staticClass:"goods-saleAttr-block"},[(_vm.goodsDetailInfo.price)?_c('div',{staticClass:"goods-saleAttr-item"},[_c('label',{staticClass:"goods-saleAttr-key"},[_vm._v("货号")]),_vm._v(" "),_c('div',{staticClass:"goods-saleAttr-val"},_vm._l((_vm.goodsDetailInfo.price),function(item,index){return _c('span',{staticClass:"goods-size-item",class:{'active':_vm.curGoodsIndex==index},on:{"click":function($event){_vm.selecteGoodsSize(index)}}},[_vm._v(_vm._s(item.p_code)+"\n\t  \t\t\t\t\t"),(item.if_promotion)?_c('i',{staticClass:"goods-size-tag"},[_vm._v("促")]):_vm._e()])}))]):_vm._e(),_vm._v(" "),_vm._l((_vm.goodsDetailInfo.price),function(item,index){return (_vm.goodsDetailInfo.price)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curGoodsIndex==index),expression:"curGoodsIndex==index"}],staticClass:"goods-salAttr-groups"},[_c('div',{staticClass:"goods-saleAttr-item"},[_c('label',{staticClass:"goods-saleAttr-key"},[_vm._v("折扣价")]),_vm._v(" "),_c('div',{staticClass:"goods-saleAttr-val"},[_c('span',{staticClass:"goods-discount"},[_vm._v("￥"+_vm._s(item.price))]),_vm._v(" "),(item.if_promotion)?_c('span',{staticClass:"goods-orPrice"},[_vm._v("￥"+_vm._s(item.market_price))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"goods-saleAttr-item"},[_c('label',{staticClass:"goods-saleAttr-key"},[_vm._v("库存")]),_vm._v(" "),_c('div',{staticClass:"goods-saleAttr-val"},[_c('span',{staticClass:"goods-store"},[_vm._v(_vm._s(item.stock))])])]),_vm._v(" "),_c('div',{staticClass:"goods-saleAttr-item"},[_c('label',{staticClass:"goods-saleAttr-key"},[_vm._v("数量")]),_vm._v(" "),_c('div',{staticClass:"goods-saleAttr-val no-border"},[_c('div',{staticClass:"number-group"},[_c('button',{staticClass:"minus-btn",class:{'disabled':_vm.selectedCount==1},on:{"click":_vm.minusNum}},[_vm._v("-")]),_vm._v(" "),_c('mt-field',{attrs:{"disableClear":true,"placeholder":"","type":"number"},on:{"change":function($event){_vm.changeNum(item.maxNum)}},model:{value:(_vm.selectedCount),callback:function ($$v) {_vm.selectedCount=$$v},expression:"selectedCount"}}),_vm._v(" "),_c('button',{staticClass:"add-btn",class:{'disabled':_vm.selectedCount>=item.maxNum},on:{"click":function($event){_vm.addNum(item.maxNum)}}},[_vm._v("+")])],1)])])]):_vm._e()})],2)]),_vm._v(" "),_c('div',{staticClass:"submit-bar"},[_c('p',{staticClass:"total-price"},[_vm._v("总价:"),_c('span',[_vm._v("￥"+_vm._s(_vm.totalPrice))])]),_vm._v(" "),_c('p',{staticClass:"price-tips"},[_vm._v("不含运费")]),_vm._v(" "),(!_vm.goodsDetailInfo.if_explode && !_vm.goodsDetailInfo.if_drag)?_c('button',{staticClass:"submit-btn",attrs:{"id":"addToShopbag"},on:{"click":_vm.addToShopbag}},[_vm._v("加入购物车")]):_vm._e(),_vm._v(" "),(_vm.goodsDetailInfo.if_explode || _vm.goodsDetailInfo.if_drag)?_c('label',{staticClass:"goods-warning"},[_c('span',[_vm._v("请联系客服购买！")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fly_item",attrs:{"id":"flyItem"}},[_vm._v("+"+_vm._s(_vm.selectedCount))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E043":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EPFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__ = __webpack_require__("oBeN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editAddr',
  data: function data() {
    return {
      addrInfo: {
        cia_city: "",
        cia_county: "",
        cia_if_default: "0",
        cia_mobile: "",
        cia_name: "",
        cia_phone: "",
        cia_province: "",
        cia_street: ""
      },
      isNew: false
    };
  },
  mounted: function mounted() {
    //获取数据
    if (this.$route.query.addrId) {
      this.getDetail();
    } else {
      this.isNew = true;
    }
    //获取焦点时移到页面可见区域
    $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
      var dom = e.target;
      setTimeout(function () {
        dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
      }, 200);
    });
  },

  methods: {
    deleteAddr: function deleteAddr() {
      var that = this;
      this.$messagebox.confirm('确定删除这条数据？', '温馨提示', { callback: function callback(type) {
          if (type == 'confirm') {
            that.$cHttp.post('cusiaddrs/delete', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              cia_id: that.$route.query.addrId
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that.$router.go(-1);
              } else {
                that.$toast('删除失败');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    saveAddr: function saveAddr() {
      var _this = this;

      // todo 表单验证
      if (this.$route.query.addrId) {
        this.$cHttp.post('cusiaddrs/edit', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey,
          user_id: this.$store.state.userInfo.user_id
        }, this.addrInfo)).then(function (res) {
          console.log(res);
          if (res.status && res.status == 1) {
            if (_this.$route.query.isSubSelect == 1) {
              _this.$router.go(-2);
              _this.$store.commit('setSelectedInvoiceAddrData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.addrInfo));
            } else {
              _this.$router.go(-1);
            }
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      } else {
        this.$cHttp.post('cusiaddrs/add', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey,
          user_id: this.$store.state.userInfo.user_id
        }, this.addrInfo)).then(function (res) {
          console.log(res);
          if (res.status && res.status == 1) {
            if (_this.$route.query.isSubSelect == 1) {
              _this.$store.commit('setSelectedInvoiceAddrData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.addrInfo));
              _this.$router.go(-2);
            } else {
              _this.$router.go(-1);
            }
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      }
    },
    setDefault: function setDefault() {
      this.addrInfo.cia_if_default = this.addrInfo.cia_if_default == 1 ? 0 : 1;
    },
    showAddr: function showAddr(type, parent) {
      this.$refs.addrSelector.showAddr(type, parent);
    },
    endSelectAddr: function endSelectAddr(vals) {
      this.addrInfo.cia_province = vals[0];
      this.addrInfo.cia_city = vals[1];
      this.addrInfo.cia_county = vals[2];
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.$cHttp.post('cusiaddrs/detail', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        cia_id: this.$route.query.addrId
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this2.addrInfo = res.data;
        } else {
          _this2.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this2.$toast(msg);
      });
    }
  },
  components: {
    AddrSelector: __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__["a" /* default */]
  }
});

/***/ }),

/***/ "EV1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("broi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4774f10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("BphF");
function injectStyle (ssrContext) {
  __webpack_require__("BnjG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4774f10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4774f10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FX7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__("GQaK");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: null
    },
    pullup: {
      type: Boolean,
      default: false
    },
    beforeScroll: {
      type: Boolean,
      default: false
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    startY: {
      type: Number,
      default: 0
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this._initScroll();
    }, 20);
  },

  methods: {
    _initScroll: function _initScroll() {
      var _this2 = this;

      if (!this.$refs.wrapper) {
        return;
      }
      this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll__["a" /* default */](this.$refs.wrapper, {
        startY: this.startY,
        probeType: this.probeType,
        click: this.click,
        preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|A)$/ }
      });

      if (this.listenScroll) {
        var me = this;
        this.scroll.on('scroll', function (pos) {
          me.$emit('scroll', _this2.scroll, _this2.scroll.maxScrollY);
        });
      }

      if (this.pullup) {
        this.scroll.on('touchEnd', function () {
          if (_this2.scroll.y > 40) {
            _this2.$emit('scrollToTop');
          } else if (_this2.scroll.y <= _this2.scroll.maxScrollY - 30) {
            _this2.$emit('scrollToEnd');
          }
        });
      }

      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', function () {
          _this2.$emit('beforeScroll', _this2.scroll.maxScrollY);
        });
      }
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  },
  watch: {
    data: function data() {
      var _this3 = this;

      setTimeout(function () {
        _this3.refresh();
      }, this.refreshDelay);
    }
  }
});

/***/ }),

/***/ "G+WG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G/wF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopBag_vue__ = __webpack_require__("Zh0b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c745ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopBag_vue__ = __webpack_require__("seVC");
function injectStyle (ssrContext) {
  __webpack_require__("sGqR")
  __webpack_require__("Jozl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9c745ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopBag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c745ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopBag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gd2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export httpRequest */
/* unused harmony export httpGet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cHttp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__ = __webpack_require__("qONS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__ = __webpack_require__("UQTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_config_systemConfig__ = __webpack_require__("yiBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);







//POST传参序列化
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  console.log(config);
  if (config.method === 'post' && config.option && !config.option.noSQ) {} else {
    config.data = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(config.data);
  }
  return config;
}, function (error) {
  console.log('错误的传参');
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a.open();
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a.close();
  return response;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a.close();
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject('网络出错了');
  if (error.response) {
    switch (error.response.status) {
      case 401:
    }
  }
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error.response.data); // 返回接口返回的错误信息
});
function httpRequest(method, data, isFullUrl, option) {
  var basicUrl = __WEBPACK_IMPORTED_MODULE_4__static_config_systemConfig__["a" /* default */].basicUrl;
  var data = data ? data : {};
  return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
    method: 'post',
    url: isFullUrl ? method : basicUrl + method,
    data: data,
    option: option
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(res.data);
  }).catch(function (msg) {
    console.log(msg);
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(msg);
  });
}
function httpGet(method, data, isFullUrl) {
  var basicUrl = __WEBPACK_IMPORTED_MODULE_4__static_config_systemConfig__["a" /* default */].basicUrl;
  var data = data ? data : {};
  var url = isFullUrl ? method : basicUrl + method;
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
    params: data
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(res.data);
  }).catch(function (msg) {
    console.log(msg);
  });
}

var cHttp = {
  get: httpGet,
  post: httpRequest
};

/***/ }),

/***/ "HhFx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IJHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true},on:{"scroll":_vm.scroll,"scrollToEnd":_vm.scrollToEnd,"scrollToTop":_vm.scrollToTop}},[_c('ul',{staticClass:"query-list"},[_c('div',{staticClass:"pullDown"},[_vm._v(_vm._s(_vm.pullDownMsg))]),_vm._v(" "),(_vm.data.length<1)?_c('p',{staticClass:"empty-list"},[_vm._v("暂无数据")]):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item",on:{"click":function($event){_vm.toDetail(item)}}},[_c('a',{staticClass:"order-item-mask",attrs:{"href":"javascript:void(0)"}}),_vm._v(" "),_c('h3',{staticClass:"list-item-orderTitle"},[_c('span',[_c('b',[_vm._v("配货单号：")]),_vm._v(_vm._s(item.dp_code))]),_vm._v(" "),_c('label',[_c('b',[_vm._v("订单号：")]),_vm._v(_vm._s(item.so_no))])]),_vm._v(" "),_c('div',{staticClass:"list-item-orderContent"},[_c('div',{staticClass:"list-item-orderPrice"},[_c('span',[_vm._v("收件人："+_vm._s(item.so_ca_name)+" ("+_vm._s(item.dp_express_com)),(item.dp_express_no)?[_vm._v(_vm._s(_vm._f("item.dp_express_no")()))]:_vm._e(),_vm._v(")")],2)]),_vm._v(" "),_c('time',{staticClass:"list-item-orderTime"},[_vm._v(_vm._s(item.dp_sendtime))])])])}),_vm._v(" "),_c('div',{staticClass:"pullUp"},[_vm._v(_vm._s(_vm.pullUpMsg))])],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "It2H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JRlI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_scroll_scroll__ = __webpack_require__("mnFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_basic_goodsItem_goodsItem__ = __webpack_require__("g5XB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoiceAddrList',
  data: function data() {
    return {
      keyWord: '',
      pageSize: 1000,
      curPage: 1,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: true,
      listenScroll: true,
      probeType: 3
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this.keyWord = this.$route.params.keyword;
    this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
    this.probeType = 3;
    this.listenScroll = true;
    this.touch = {};

    this._getData(true);
  },

  methods: {
    selectAddrItem: function selectAddrItem(item) {
      if (this.$route.params.isSelect == 'true') {
        //选择地址
        console.log(item);
        this.$store.commit('setSelectedInvoiceAddrData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item));
        this.$router.back();
      }
    },
    setDefault: function setDefault(item) {
      var _this = this;

      this.$cHttp.post('cusiaddrs/edit', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id
      }, item, {
        cia_if_default: '1'
      })).then(function (res) {
        //console.log(res)
        if (res.status && res.status == 1) {
          _this._getData();
        } else {
          _this.$toast(res.error_msg);
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
      /*for(var i=0;i<this.data.length;i++){
      	this.data[i].isDefault=false;
      }
      item.isDefault=!item.isDefault;*/
    },
    newAddr: function newAddr() {
      this.$store.commit('setEidtAddrData', {});
      this.$router.push({ path: '/InvoiceEditAddr?isSubSelect=' + this.$route.query.isSubSelect });
    },
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },

    /* scroll(scrollPos,maxY) {
       if (scrollPos.y > 30) {
         this.pullDownMsg='释放刷新';
       }
       if(scrollPos.y<= (maxY - 40)&&this.hasMore){
     		this.pullUpMsg='释放加载更多';
       }
     },
     scrollToEnd(){
     	if(this.hasMore){
     		this._getData();
     	}
      },
     scrollToTop(){
     	this.hasMore=true;
     	this.curPage=0;
       this._getData(true);
     },*/
    editAddr: function editAddr(item) {
      //this.$store.commit('setEidtAddrData',item);
      this.$router.push({ path: '/InvoiceEditAddr?addrId=' + item.cia_id + '&isSubSelect=' + this.$route.query.isSubSelect });
    },
    deleteAddr: function deleteAddr(item) {
      var that = this;
      this.$messagebox.confirm('确定删除这条数据？', '温馨提示', { callback: function callback(type) {
          if (type == 'confirm') {
            that.$cHttp.post('cusiaddrs/delete', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              cia_id: item.cia_id
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that._getData();
              } else {
                that.$toast('删除失败');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    searchSub: function searchSub(keyWord) {
      this.keyWord = keyWord;
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
      this.$refs.listview.scrollTo(0, 0);
    },
    _getData: function _getData(clear) {
      var _this2 = this;

      this.$cHttp.post('cusiaddrs/index', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        page_pernum: this.pageSize,
        current_page: this.curPage
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this2.data = res.data.rows;
          if (_this2.$route.params.isSelect) {
            var selectedId = _this2.$store.state.selectedInvoiceAddrData.cia_id;
            for (var i = 0; i < _this2.data.length; i++) {
              if (_this2.data[i].cia_id == selectedId) {
                _this2.data[i].isSelected = true;
              } else {
                _this2.data[i].isSelected = false;
              }
            }
          }
        } else {
          _this2.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this2.$toast(msg);
      });

      //计算数据是否为选中地址
      /*
      if(clear){
      	this.data=tempListData;
      }else{
      	this.data=this.data.concat(tempListData);
      }*/
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_2_basic_scroll_scroll__["a" /* default */], GoodsItem: __WEBPACK_IMPORTED_MODULE_3_basic_goodsItem_goodsItem__["a" /* default */], SearchBlock: __WEBPACK_IMPORTED_MODULE_4_basic_searchBlock_searchBlock__["a" /* default */]
  }
});

/***/ }),

/***/ "JY51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerBar_vue__ = __webpack_require__("n6Xk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ab5cb42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerBar_vue__ = __webpack_require__("2QV3");
function injectStyle (ssrContext) {
  __webpack_require__("iTzp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ab5cb42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jgzl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-bg-r5.1d0132a.jpg";

/***/ }),

/***/ "Jozl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LBiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepay_vue__ = __webpack_require__("Obar");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94e3a978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepay_vue__ = __webpack_require__("BSvw");
function injectStyle (ssrContext) {
  __webpack_require__("HhFx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94e3a978"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94e3a978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LTKR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchIndex_vue__ = __webpack_require__("Mllm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7f6f8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchIndex_vue__ = __webpack_require__("LsCy");
function injectStyle (ssrContext) {
  __webpack_require__("E043")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb7f6f8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7f6f8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ln+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true}},[_c('ul',{staticClass:"query-list"},[_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item",on:{"click":function($event){_vm.selectAddrItem(item)}}},[(_vm.$route.params.isSelect=='true')?_c('i',{staticClass:"mint-checkbox-core",class:{'checked':item.isSelected}}):_vm._e(),_vm._v(" "),_c('div',[_c('h3',{staticClass:"addr-user"},[_c('label',{staticClass:"name"},[_vm._v(_vm._s(item.ca_name))]),_c('span',{staticClass:"telNum"},[_vm._v(_vm._s(item.ca_mobile))])]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.ca_province))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.ca_city))]),_vm._v(" "),_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.ca_county))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(item.ca_street))])]),_vm._v(" "),_c('div',{staticClass:"opr-bar"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.params.isSelect!='true'),expression:"$route.params.isSelect!='true'"}],staticClass:"set-default-group",class:{'active':item.ca_if_default==1},on:{"click":function($event){$event.stopPropagation();_vm.setDefault(item)}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':item.ca_if_default==1}}),_vm._v("\n\t\t        \t\t\t"+_vm._s(item.ca_if_default==1?'默认地址':'设为默认地址'))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.params.isSelect=='true'),expression:"$route.params.isSelect=='true'"}],staticClass:"set-default-group",class:{'active':item.ca_if_default==1}},[_vm._v("\n\t\t        \t\t\t"+_vm._s(item.ca_if_default==1?'默认地址':'')+"\n\t\t        \t\t")]),_vm._v(" "),_c('p',{staticClass:"opr-btns"},[_c('a',{staticClass:"opr-btn edit",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.stopPropagation();_vm.editAddr(item)}}}),_vm._v(" "),_c('a',{staticClass:"opr-btn delete",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.stopPropagation();_vm.deleteAddr(item)}}})])])])])}),_vm._v(" "),_c('div',{staticClass:"add-group",staticStyle:{"padding":".2rem"}},[_c('mt-button',{attrs:{"size":"large","type":"danger"},on:{"click":_vm.newAddr}},[_vm._v("新增")])],1)],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LsCy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('img',{staticClass:"banner-img",attrs:{"src":__webpack_require__("Jgzl")}}),_vm._v(" "),_c('img',{staticClass:"logo-icon",attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('form',{staticClass:"search-group inputcontent",attrs:{"action":"javascript:void(0);"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyWord),expression:"keyWord"}],staticClass:"search-input inputcontent",attrs:{"type":"search","placeholder":"请输入品名、货号、CAS号或关键字"},domProps:{"value":(_vm.keyWord)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.searchSub($event)},"input":function($event){if($event.target.composing){ return; }_vm.keyWord=$event.target.value}}}),_c('button',{staticClass:"search-btn",on:{"click":_vm.searchSub}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lv0g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a37da67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("hmnP");
function injectStyle (ssrContext) {
  __webpack_require__("Mk+A")
  __webpack_require__("iz09")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a37da67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MbcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('form',{staticClass:"addr-form",attrs:{"name":"addrForm","action":"javascript:void(0)"}},[_c('div',{staticClass:"invoice-type"},[_c('p',{staticClass:"invoice-type-item",on:{"click":function($event){_vm.setInvoiceType('1')}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.invoiceInfo.ci_type=='1'}}),_vm._v("普通发票")]),_vm._v(" "),_c('p',{staticClass:"invoice-type-item",on:{"click":function($event){_vm.setInvoiceType('2')}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.invoiceInfo.ci_type=='2'}}),_vm._v("专用发票 ")])]),_vm._v(" "),[_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"开票抬头","readonly":"","placeholder":"请输入开票抬头"},model:{value:(_vm.invoiceInfo.ci_title),callback:function ($$v) {_vm.invoiceInfo.ci_title=$$v},expression:"invoiceInfo.ci_title"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"税号","placeholder":"请输入税号"},model:{value:(_vm.invoiceInfo.ci_vatno),callback:function ($$v) {_vm.invoiceInfo.ci_vatno=$$v},expression:"invoiceInfo.ci_vatno"}})],_vm._v(" "),(_vm.invoiceInfo.ci_type=='2')?[_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"开户行","placeholder":"请输入开户行"},model:{value:(_vm.invoiceInfo.ci_bank),callback:function ($$v) {_vm.invoiceInfo.ci_bank=$$v},expression:"invoiceInfo.ci_bank"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"银行账号","placeholder":"请输入银行账号","type":"number"},model:{value:(_vm.invoiceInfo.ci_bknum),callback:function ($$v) {_vm.invoiceInfo.ci_bknum=$$v},expression:"invoiceInfo.ci_bknum"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"开票地址","placeholder":"请输入开票地址","type":"textarea"},model:{value:(_vm.invoiceInfo.ci_addr),callback:function ($$v) {_vm.invoiceInfo.ci_addr=$$v},expression:"invoiceInfo.ci_addr"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"开票电话","placeholder":"请输入开票电话","type":"number"},model:{value:(_vm.invoiceInfo.ci_phone),callback:function ($$v) {_vm.invoiceInfo.ci_phone=$$v},expression:"invoiceInfo.ci_phone"}})]:_vm._e(),_vm._v(" "),_c('p',{staticClass:"set-default-group",on:{"click":_vm.setDefault}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.invoiceInfo.ci_if_default=='1'}}),_vm._v("设为默认值")]),_vm._v(" "),_c('div',{staticClass:"opr-group"},[_c('mt-button',{attrs:{"size":"large","plain":""},on:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"btn-div"}),_vm._v(" "),(!_vm.isNew)?_c('mt-button',{attrs:{"size":"large","type":"danger","plain":""},on:{"click":_vm.deleteInvocie}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-div"}),_vm._v(" "),_c('mt-button',{attrs:{"size":"large","type":"danger"},on:{"click":_vm.saveInvocie}},[_vm._v("保存")])],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mk+A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mllm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'searchIndex',
	data: function data() {
		return {
			keyWord: ''
		};
	},
	mounted: function mounted() {
		if (this.$route.meta && this.$route.meta.pageBelong) {
			this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
		}
		//获取焦点时移到页面可见区域
		$('.inputcontent input').unbind('focus').bind('focus', function (e) {
			var dom = e.target;
			setTimeout(function () {
				dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
			}, 200);
			setTimeout(function () {
				dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
			}, 400);
			setTimeout(function () {
				dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
			}, 600);
		});
	},

	methods: {
		searchSub: function searchSub() {
			this.$router.push({ path: '/GoodsList/' + this.keyWord });
		},
		ifWeChat: function ifWeChat() {
			var ua = window.navigator.userAgent.toLowerCase();
			return ua.match(/MicroMessenger/i) == 'micromessenger';
		}
	},
	components: {}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__ = __webpack_require__("qONS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__ = __webpack_require__("UQTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css__ = __webpack_require__("OgVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box__ = __webpack_require__("/Lyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_lazyload_style_css__ = __webpack_require__("+NoH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_lazyload_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_lazyload_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_lazyload__ = __webpack_require__("w3jz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__ = __webpack_require__("97Sy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__ = __webpack_require__("bCKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_actionsheet_style_css__ = __webpack_require__("CcXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_actionsheet_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_actionsheet_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_actionsheet__ = __webpack_require__("fKbY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_actionsheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_actionsheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_field_style_css__ = __webpack_require__("f1Vh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_field_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_field_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_field__ = __webpack_require__("ZQVe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_button_style_css__ = __webpack_require__("y+mr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_button__ = __webpack_require__("3JdW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_toast_style_css__ = __webpack_require__("34+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_toast__ = __webpack_require__("X+yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_popup_style_css__ = __webpack_require__("q/am");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_popup_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_popup_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_popup__ = __webpack_require__("4VPn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_picker_style_css__ = __webpack_require__("44/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_picker_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_picker_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_picker__ = __webpack_require__("utzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_checklist_style_css__ = __webpack_require__("PTD1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_checklist_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_checklist_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_checklist__ = __webpack_require__("B7Ql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_checklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_checklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_js__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__static_config_systemConfig__ = __webpack_require__("yiBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_common_js_httpRequest__ = __webpack_require__("Gd2r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_common_css_cssreset_css__ = __webpack_require__("Xejd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_common_css_cssreset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_common_css_cssreset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_common_css_paramcss_scss__ = __webpack_require__("RVoj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_common_css_paramcss_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_common_css_paramcss_scss__);






















// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'



// Vue.use(MintUI)
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_checklist___default.a.name, __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_checklist___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_picker___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_popup___default.a.name, __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_popup___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_toast___default.a.name, __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_toast___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_field___default.a.name, __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_field___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_actionsheet___default.a.name, __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_actionsheet___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_actionsheet___default.a);
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].$messagebox = __WEBPACK_IMPORTED_MODULE_22_vue__["default"].prototype.$messagebox = __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].$toast = __WEBPACK_IMPORTED_MODULE_22_vue__["default"].prototype.$toast = __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_toast___default.a;
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].$indicator = __WEBPACK_IMPORTED_MODULE_22_vue__["default"].prototype.$indicator = __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a;
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].$indicator = __WEBPACK_IMPORTED_MODULE_22_vue__["default"].prototype.$Actionsheet = __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_actionsheet___default.a;

__WEBPACK_IMPORTED_MODULE_22_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].prototype.$systemConfig = __WEBPACK_IMPORTED_MODULE_26__static_config_systemConfig__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_22_vue__["default"].prototype.$cHttp = __WEBPACK_IMPORTED_MODULE_27_common_js_httpRequest__["a" /* cHttp */];

__WEBPACK_IMPORTED_MODULE_24__router__["a" /* default */].beforeEach(function (to, from, next) {
  //如果不是微信浏览器则跳转至手机页面
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    window.location.href = 'http://m.rhawn.cn';
  }
  next();
});

new __WEBPACK_IMPORTED_MODULE_22_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_25__store_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_24__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_23__App__["a" /* default */] }
});
document.body.addEventListener('touchstart', function () {});

/***/ }),

/***/ "Ni3J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orderInfo.so_no)?_c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"order-status"},[_c('label',[_vm._v("订单号："+_vm._s(_vm.orderInfo.so_no))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderStatusMap[_vm.orderInfo.so_review_status])+"/"+_vm._s(_vm.orderTypeMap[_vm.orderInfo.so_pay_status]))])]),_vm._v(" "),_c('div',{staticClass:"order-time"},[_c('label',[_vm._v("订单时间："+_vm._s(_vm.orderInfo.so_ctime))])]),_vm._v(" "),_c('div',{staticClass:"order-addr"},[_c('h3',{staticClass:"block-title"},[_vm._v("收货地址")]),_vm._v(" "),_c('h3',{staticClass:"addr-user"},[_c('label',{staticClass:"name"},[_vm._v(_vm._s(_vm.orderInfo.so_ca_name))]),_c('span',{staticClass:"telNum"},[_vm._v(_vm._s(_vm.orderInfo.so_ca_mobile))]),_c('span',{staticClass:"telNum"},[_vm._v("  "+_vm._s(_vm.orderInfo.so_ca_phone))])]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_ca_province))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_ca_city))]),_vm._v(" "),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_ca_county))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_ca_street))])])]),_vm._v(" "),_c('div',{staticClass:"order-invoice"},[_c('h3',{staticClass:"block-title"},[_vm._v("收票信息")]),_vm._v(" "),_c('p',{staticClass:"invoice-company"},[_vm._v(_vm._s(_vm.orderInfo.so_cia_name)+"    "+_vm._s(_vm.orderInfo.so_cia_mobile)+"   "+_vm._s(_vm.orderInfo.so_cia_phone))]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_cia_province))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_cia_city))]),_vm._v(" "),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_cia_county))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_cia_street))])])]),_vm._v(" "),_c('div',{staticClass:"order-invoice"},[_c('h3',{staticClass:"block-title"},[_vm._v("发票信息")]),_vm._v(" "),(_vm.orderInfo.so_ci_method==3)?_c('div',{staticClass:"invoice-company invoice-info-item"},[_vm._v("不开发票")]):[_c('p',{staticClass:"invoice-company invoice-info-item",staticStyle:{"line-height":".2rem"}},[_vm._v(_vm._s(_vm.orderInfo.so_ci_title)+" "),_c('br'),_vm._v("  "+_vm._s(_vm.orderInfo.so_ci_vatno))]),_vm._v(" "),(_vm.orderInfo.so_ci_type==2)?[_c('p',{staticClass:"invoice-info-item"},[_c('label',[_vm._v("开户行:")]),_c('span',[_vm._v(_vm._s(_vm.orderInfo.so_ci_bank))])]),_vm._v(" "),_c('p',{staticClass:"invoice-info-item"},[_c('label',[_vm._v("银行账号:")]),_c('span',[_vm._v(_vm._s(_vm.orderInfo.so_ci_bknum))])]),_vm._v(" "),_c('p',{staticClass:"invoice-info-item"},[_c('label',[_vm._v("开票电话:")]),_c('span',[_vm._v(_vm._s(_vm.orderInfo.so_ci_phone))])]),_vm._v(" "),_c('p',{staticClass:"invoice-info-item"},[_c('label',[_vm._v("开票方式:")]),_c('span',[_vm._v(_vm._s(_vm.invoiceTypeMap[_vm.orderInfo.so_ci_method]))])]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.orderInfo.so_ci_addr))])])]:_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"goods-list-box"},[_c('h3',{staticClass:"block-title"},[_vm._v("商品信息")]),_vm._v(" "),(_vm.orderInfo.soitems&&_vm.orderInfo.soitems.length)?_c('ul',{staticClass:"goods-list"},_vm._l((_vm.orderInfo.soitems),function(item,index){return _c('li',{staticClass:"goods-list-item",on:{"click":function($event){_vm.toDetail(item)}}},[_c('order-item',{attrs:{"goodsData":item,"readOnly":true,"isDetailItem":true}})],1)})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-price"},[_c('div',{staticStyle:{"float":"left"}},[_c('label',[_vm._v("运费：")]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(_vm.orderInfo.express))])]),_vm._v(" "),_c('label',[_vm._v("总计：")]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(_vm.orderInfo.so_total))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OFlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('form',{staticClass:"edit-form addr-form",attrs:{"name":"editForm","action":"javascript:void(0)"}},[_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"电子邮箱","readonly":"","placeholder":""},model:{value:(_vm.$store.state.userInfo.user_email),callback:function ($$v) {_vm.$store.state.userInfo.user_email=$$v},expression:"$store.state.userInfo.user_email"}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('p',{staticClass:"set-password",on:{"click":_vm.switchPassword}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.setPassword}}),_vm._v("修改密码")])]),_vm._v(" "),(_vm.setPassword)?[_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"原密码","type":"password","placeholder":""},model:{value:(_vm.oldPassword),callback:function ($$v) {_vm.oldPassword=$$v},expression:"oldPassword"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"设置密码","type":"password","placeholder":""},model:{value:(_vm.basicInfo.cus_password),callback:function ($$v) {_vm.basicInfo.cus_password=$$v},expression:"basicInfo.cus_password"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"确认密码","type":"password","placeholder":""},model:{value:(_vm.rePassword),callback:function ($$v) {_vm.rePassword=$$v},expression:"rePassword"}})]:_vm._e(),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"姓名","placeholder":""},model:{value:(_vm.basicInfo.cus_name),callback:function ($$v) {_vm.basicInfo.cus_name=$$v},expression:"basicInfo.cus_name"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"手机","placeholder":""},model:{value:(_vm.basicInfo.cus_mobile),callback:function ($$v) {_vm.basicInfo.cus_mobile=$$v},expression:"basicInfo.cus_mobile"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"座机","placeholder":""},model:{value:(_vm.basicInfo.cus_phone),callback:function ($$v) {_vm.basicInfo.cus_phone=$$v},expression:"basicInfo.cus_phone"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"传值","placeholder":""},model:{value:(_vm.basicInfo.cus_fax),callback:function ($$v) {_vm.basicInfo.cus_fax=$$v},expression:"basicInfo.cus_fax"}}),_vm._v(" "),_c('div',{staticClass:"opr-group"},[_c('mt-button',{attrs:{"size":"large","type":"danger"},on:{"click":_vm.saveBasicInfo}},[_vm._v("保存")])],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OHuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      selectedCount: 1
    };
  },

  props: {
    maxNum: {
      type: Number,
      default: 1
    },
    minNum: {
      type: Number,
      default: 1
    },
    orNum: {
      type: Number,
      default: 1
    }
  },
  mounted: function mounted() {
    this.selectedCount = this.orNum;
  },

  methods: {
    minusNum: function minusNum() {
      if (this.selectedCount <= this.minNum) return;
      this.selectedCount = this.selectedCount - 1;
      this.$emit('changeNum', this.selectedCount);
    },
    addNum: function addNum(maxNum) {
      if (this.selectedCount == maxNum) return;
      this.selectedCount = this.selectedCount + 1;
      this.$emit('changeNum', this.selectedCount);
    },
    changeNum: function changeNum(maxNum) {
      if (this.selectedCount < this.minNum) {
        this.selectedCount = 1;
      } else if (this.selectedCount > maxNum) {
        this.selectedCount = maxNum;
      }
      this.$emit('changeNum', this.selectedCount);
    }
  },
  components: {}
});

/***/ }),

/***/ "Ob3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('section',{staticClass:"order-tab-header"},[_c('ul',{staticClass:"order-tab-list"},[_c('li',{staticClass:"order-tab-item",class:{'active':_vm.$store.state.curOrderType=='all'},on:{"click":function($event){_vm.setListType('all',null)}}},[_vm._v("全部")]),_vm._v(" "),_c('li',{staticClass:"order-tab-item",class:{'active':_vm.$store.state.curOrderType=='tocheck'},on:{"click":function($event){_vm.setListType('tocheck',0)}}},[_vm._v("待审核")]),_vm._v(" "),_c('li',{staticClass:"order-tab-item",class:{'active':_vm.$store.state.curOrderType=='checkedorder'},on:{"click":function($event){_vm.setListType('checkedorder',1)}}},[_vm._v("已审核")]),_vm._v(" "),_c('li',{staticClass:"order-tab-item",class:{'active':_vm.$store.state.curOrderType=='cancel'},on:{"click":function($event){_vm.setListType('cancel',3)}}},[_vm._v("已取消")])])]),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true},on:{"scroll":_vm.scroll,"scrollToEnd":_vm.scrollToEnd,"scrollToTop":_vm.scrollToTop}},[_c('ul',{staticClass:"query-list"},[_c('div',{staticClass:"pullDown"},[_vm._v(_vm._s(_vm.pullDownMsg))]),_vm._v(" "),(_vm.data.length<1)?_c('p',{staticClass:"empty-list"},[_vm._v("暂无数据")]):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item",on:{"click":function($event){_vm.toDetail(item)}}},[_c('a',{staticClass:"order-item-mask",attrs:{"href":"javascript:void(0)"}}),_vm._v(" "),_c('h3',{staticClass:"list-item-orderTitle"},[_c('label',[_c('b',[_vm._v("订单号：")]),_vm._v(_vm._s(item.so_no))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderStatusMap[item.so_review_status])+"/"+_vm._s(_vm.orderTypeMap[item.so_pay_status]))])]),_vm._v(" "),_c('div',{staticClass:"list-item-orderContent"},[_c('div',{staticClass:"list-item-orderPrice"},[_c('span',[_vm._v("共"+_vm._s(item.nums)+"件商品  ")]),_vm._v(" "),_c('label',[_vm._v("总价："),_c('b',[_vm._v("￥"+_vm._s(item.so_total))])])]),_vm._v(" "),_c('time',{staticClass:"list-item-orderTime"},[_vm._v(_vm._s(item.so_ctime))])]),_vm._v(" "),(item.so_pay_status==0&&item.so_review_status==0)?_c('div',{staticClass:"list-item-oprBar"},[_c('button',{staticClass:"list-item-oprBtn red",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.payOrder(item)}}},[_vm._v("支付")]),_vm._v(" "),_c('button',{staticClass:"list-item-oprBtn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.cancelOrder(item)}}},[_vm._v("取消")])]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"pullUp"},[_vm._v(_vm._s(_vm.pullUpMsg))])],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Obar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__ = __webpack_require__("mnFd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      keyWord: '',
      curPage: 1,
      pageSize: 15,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: true,
      listenScroll: true,
      probeType: 3,
      orderStatusMap: ['未审核', '审核通过', '审核通过', '已取消'],
      orderTypeMap: ['未付款', '部分付款', '全额付款']
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this._getData(true);
  },

  methods: {
    searchSub: function searchSub(keyWord) {
      this.$router.push({ path: '/GoodsList/' + keyWord });
    },
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },
    scroll: function scroll(scrollPos, maxY) {
      if (scrollPos.y > 30) {
        this.pullDownMsg = '释放刷新';
      }
      if (scrollPos.y <= maxY - 40 && this.hasMore) {
        this.pullUpMsg = '释放加载更多';
      }
    },
    scrollToEnd: function scrollToEnd() {
      if (this.hasMore) {
        this._getData();
      }
    },
    scrollToTop: function scrollToTop() {
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
    },
    payOrder: function payOrder(item) {
      //先查支付信息  在跳支付页面
      this.$router.push({ path: '/PayInfo/' });
    },
    cancelOrder: function cancelOrder(item) {
      this.$toast('取消订单');
    },
    setListType: function setListType(type, status) {
      this.$store.commit('setCurOrderType', type);
      this.scrollToTop();
      this.$refs.listview.scrollTo(0, 0);
    },
    _getData: function _getData(clear) {
      var _this = this;

      this.$cHttp.post('customers/prepaylog', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        page_pernum: this.pageSize,
        current_page: this.curPage
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          if (clear) {
            _this.$store.commit('setSubOrderInfo', {
              cus_prepay: res.data.cus_prepay,
              so_no: '',
              so_id: '',
              so_total: 0
            });
            _this.data = res.data.rows;
          } else {
            _this.data = _this.data.concat(res.data.rows);
          }
          if (_this.curPage + 1 > res.data.total_page) {
            _this.hasMore = false;
            _this.pullUpMsg = '没有更多数据了';
          } else {
            _this.curPage++;
          }
          if (res.data.rows.length < 1) {
            _this.$toast('暂无数据');
          }
        } else {
          _this.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    }
  },
  components: {
    SearchBlock: __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__["a" /* default */], Scroll: __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__["a" /* default */]
  }
});

/***/ }),

/***/ "OgVB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PTD1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PsGa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderItem_vue__ = __webpack_require__("6jeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7199a1d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderItem_vue__ = __webpack_require__("sYRM");
function injectStyle (ssrContext) {
  __webpack_require__("zCQ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7199a1d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7199a1d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QzEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"search-group",attrs:{"action":"javascript:void(0);"}},[_c('img',{staticClass:"search-logo",attrs:{"src":__webpack_require__("l23d")}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyWord),expression:"keyWord"}],ref:"searchInput",staticClass:"search-input",attrs:{"type":"search","placeholder":"请输入品名、货号、CAS号或关键字"},domProps:{"value":(_vm.keyWord)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.searchSub($event)},"input":function($event){if($event.target.composing){ return; }_vm.keyWord=$event.target.value}}}),_c('button',{staticClass:"search-btn",on:{"click":_vm.searchSub}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R6pA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsList_vue__ = __webpack_require__("+hDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_405e85e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_goodsList_vue__ = __webpack_require__("S2fg");
function injectStyle (ssrContext) {
  __webpack_require__("hLvk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-405e85e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_405e85e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_goodsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RA9a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RAdM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsDetail_vue__ = __webpack_require__("58y8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04aed398_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_goodsDetail_vue__ = __webpack_require__("Dea0");
function injectStyle (ssrContext) {
  __webpack_require__("Lv0g")
  __webpack_require__("+nNt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04aed398"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04aed398_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_goodsDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RKUm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RVoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RYaw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S2fg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true},on:{"scroll":_vm.scroll,"scrollToEnd":_vm.scrollToEnd,"scrollToTop":_vm.scrollToTop}},[_c('ul',{staticClass:"query-list"},[_c('div',{staticClass:"pullDown"},[_vm._v(_vm._s(_vm.pullDownMsg))]),_vm._v(" "),(_vm.data.length<1)?_c('p',{staticClass:"empty-list"},[_vm._v("暂无数据")]):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item",on:{"click":function($event){_vm.toDetail(item)}}},[_c('goods-item',{attrs:{"goodsData":item}})],1)}),_vm._v(" "),_c('div',{staticClass:"pullUp"},[_vm._v(_vm._s(_vm.pullUpMsg))])],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SDj6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SaeF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sf5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SqtP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showServerItems)?_c('div',{staticClass:"server-mask"}):_vm._e(),_vm._v(" "),(_vm.showServerItems)?_c('button',{staticClass:"server-close-btn",on:{"click":_vm.closeServer}}):_vm._e(),_vm._v(" "),(_vm.showServerItems)?_c('div',{staticClass:"server-items-warpper"},[_c('server-item')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-bg"},[_c('img',{staticClass:"user-avatar",attrs:{"src":__webpack_require__("l23d")}}),_vm._v(" "),_c('div',{staticClass:"page-outbox"},[_c('form',{staticClass:"register-form inputcontent",attrs:{"name":"registerForm","action":"javascript:void(0);"}},[_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("电子邮箱")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.cus_email),expression:"registerData.cus_email"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.cus_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.cus_email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("设置密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.cus_password),expression:"registerData.cus_password"}],staticClass:"form-input username",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.registerData.cus_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.cus_password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("确认密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.cus_re_password),expression:"registerData.cus_re_password"}],staticClass:"form-input username",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.registerData.cus_re_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.cus_re_password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("姓名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.cus_name),expression:"registerData.cus_name"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.cus_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.cus_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("手机")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.cus_mobile),expression:"registerData.cus_mobile"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.cus_mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.cus_mobile=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',[_vm._v("座机")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.cus_phone),expression:"registerData.cus_phone"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.cus_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.cus_phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',[_vm._v("传真")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.cus_fax),expression:"registerData.cus_fax"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.cus_fax)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.cus_fax=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("所属地区")]),_vm._v(" "),_c('p',{staticClass:"area-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ca_province),expression:"registerData.ca_province"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ca_province)},on:{"click":function($event){_vm.showAddr('province')},"input":function($event){if($event.target.composing){ return; }_vm.registerData.ca_province=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ca_city),expression:"registerData.ca_city"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ca_city)},on:{"click":function($event){_vm.showAddr('city',_vm.registerData.ca_province)},"input":function($event){if($event.target.composing){ return; }_vm.registerData.ca_city=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ca_county),expression:"registerData.ca_county"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ca_county)},on:{"click":function($event){_vm.showAddr('county',_vm.registerData.ca_city)},"input":function($event){if($event.target.composing){ return; }_vm.registerData.ca_county=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("街道地址")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ca_street),expression:"registerData.ca_street"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ca_street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.ca_street=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("开票类型")]),_vm._v(" "),_c('div',{staticClass:"invoice-type"},[_c('p',{staticClass:"invoice-type-item",on:{"click":function($event){_vm.setInvoiceType('1')}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.registerData.ci_type=='1'}}),_vm._v("普通发票")]),_vm._v(" "),_c('p',{staticClass:"invoice-type-item",on:{"click":function($event){_vm.setInvoiceType('2')}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.registerData.ci_type=='2'}}),_vm._v("专用发票 ")])])]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("开票抬头")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ci_title),expression:"registerData.ci_title"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ci_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.ci_title=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("税号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ci_vatno),expression:"registerData.ci_vatno"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ci_vatno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.ci_vatno=$event.target.value}}})]),_vm._v(" "),(_vm.registerData.ci_type=='2')?[_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("开户行")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ci_bank),expression:"registerData.ci_bank"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ci_bank)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.ci_bank=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("银行账号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ci_bknum),expression:"registerData.ci_bknum"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ci_bknum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.ci_bknum=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("开票地址")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ci_addr),expression:"registerData.ci_addr"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ci_addr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.ci_addr=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group required"},[_c('label',[_vm._v("开票电话")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.ci_phone),expression:"registerData.ci_phone"}],staticClass:"form-input username",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.registerData.ci_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registerData.ci_phone=$event.target.value}}})])]:_vm._e(),_vm._v(" "),_c('p',{staticClass:"form-link"},[_c('label',{class:{'active':_vm.isAgree},on:{"click":_vm.agreeServer}},[_vm._v("同意本应用"),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toServer}},[_vm._v("《服务条款》")])])])],2)]),_vm._v(" "),_c('button',{staticClass:"form-btn",on:{"click":_vm.registerSub}},[_vm._v("注  册")]),_vm._v(" "),_c('addr-selector',{ref:"addrSelector",attrs:{"curProvince":_vm.registerData.ca_province,"curCity":_vm.registerData.ca_city,"curCounty":_vm.registerData.ca_county},on:{"endSelectAddr":_vm.endSelectAddr}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tdg0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tpo3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"content-wapper"},[_c('div',{staticClass:"user-banner"},[_c('img',{staticClass:"user-avatar",attrs:{"src":_vm.headImgUrl}}),_vm._v(" "),_c('h3',{staticClass:"user-name"},[_vm._v(_vm._s(this.$store.state.userInfo.user_name))]),_vm._v(" "),_c('i',{staticClass:"setting-icon",on:{"click":_vm.setBasicInfo}})]),_vm._v(" "),_c('div',{staticClass:"my-order-box"},[_c('div',{staticClass:"info-title"},[_vm._v("我的订单")]),_vm._v(" "),_c('ul',{staticClass:"my-order-menus"},[_c('li',{staticClass:"my-order-menu-item",on:{"click":function($event){_vm.toOrderList('all')}}},[_c('img',{staticClass:"my-order-menu-icon",attrs:{"src":__webpack_require__("nN3f")}}),_vm._v(" "),_c('p',[_vm._v("全部订单")])]),_vm._v(" "),_c('li',{staticClass:"my-order-menu-item",on:{"click":function($event){_vm.toOrderList('tocheck')}}},[_c('img',{staticClass:"my-order-menu-icon",attrs:{"src":__webpack_require__("s0E0")}}),_vm._v(" "),_c('p',[_vm._v("待审核")]),_vm._v(" "),(_vm.orderNum.toCheck)?_c('i',{staticClass:"order-num"},[_vm._v(_vm._s(_vm.orderNum.toCheck))]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"my-order-menu-item",on:{"click":function($event){_vm.toOrderList('checkedorder')}}},[_c('img',{staticClass:"my-order-menu-icon",attrs:{"src":__webpack_require__("/FEU")}}),_vm._v(" "),_c('p',[_vm._v("已审核")]),_vm._v(" "),(_vm.orderNum.checked)?_c('i',{staticClass:"order-num"},[_vm._v(_vm._s(_vm.orderNum.checked))]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"my-order-menu-item",on:{"click":function($event){_vm.toOrderList('cancel')}}},[_c('img',{staticClass:"my-order-menu-icon",attrs:{"src":__webpack_require__("WTKX")}}),_vm._v(" "),_c('p',[_vm._v("已取消")])])])]),_vm._v(" "),_c('div',{staticClass:"my-info-box"},[_c('div',{staticClass:"info-title"},[_vm._v("我的信息")]),_vm._v(" "),_c('div',{staticClass:"account-info"},[_c('ul',{staticClass:"account-info-list"},[_c('li',{staticClass:"account-list-item",on:{"click":_vm.toPrepay}},[_c('h3',{staticClass:"account-info-item-val"},[_vm._v("￥"+_vm._s(_vm.$store.state.subOrderInfo.cus_prepay))]),_vm._v(" "),_c('p',{staticClass:"account-info-item-name"},[_vm._v("我的预存款")])])])]),_vm._v(" "),_c('div',{staticClass:"user-menu-box"},[_c('ul',{staticClass:"user-menu-list"},[_c('li',{staticClass:"user-menu-list-item",on:{"click":_vm.toShopBag}},[_c('img',{staticClass:"user-menu-list-icon",attrs:{"src":__webpack_require__("DDRM")}}),_vm._v(" "),_c('label',{staticClass:"user-menu-list-name"},[_vm._v("我的购物车")])]),_vm._v(" "),_c('li',{staticClass:"user-menu-list-item",on:{"click":_vm.toPackageList}},[_c('img',{staticClass:"user-menu-list-icon",attrs:{"src":__webpack_require__("XkmV")}}),_vm._v(" "),_c('label',{staticClass:"user-menu-list-name"},[_vm._v("我的配货单")])]),_vm._v(" "),_c('li',{staticClass:"user-menu-list-item",on:{"click":_vm.toAddrList}},[_c('img',{staticClass:"user-menu-list-icon",attrs:{"src":__webpack_require__("mGVq")}}),_vm._v(" "),_c('label',{staticClass:"user-menu-list-name"},[_vm._v("收货地址管理")])]),_vm._v(" "),_c('li',{staticClass:"user-menu-list-item",on:{"click":_vm.toInvoiceAddrList}},[_c('img',{staticClass:"user-menu-list-icon",attrs:{"src":__webpack_require__("mGVq")}}),_vm._v(" "),_c('label',{staticClass:"user-menu-list-name"},[_vm._v("收票地址管理")])]),_vm._v(" "),_c('li',{staticClass:"user-menu-list-item",on:{"click":_vm.toInvoiceList}},[_c('img',{staticClass:"user-menu-list-icon",attrs:{"src":__webpack_require__("/7yX")}}),_vm._v(" "),_c('label',{staticClass:"user-menu-list-name"},[_vm._v("发票管理")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ULTG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VDv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkItem_vue__ = __webpack_require__("oJ4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7717c8c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkItem_vue__ = __webpack_require__("y7ZL");
function injectStyle (ssrContext) {
  __webpack_require__("/UM/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7717c8c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7717c8c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VR2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_checkItem_checkItem__ = __webpack_require__("VDv/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchIndex',
  data: function data() {
    return {};
  },

  props: {
    goodsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    selecteable: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {},
  methods: {
    selectItem: function selectItem() {
      this.$emit('selectItem', this.index);
    }
  },
  components: {
    CheckItem: __WEBPACK_IMPORTED_MODULE_0_basic_checkItem_checkItem__["a" /* default */]
  }
});

/***/ }),

/***/ "VRac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__ = __webpack_require__("oBeN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editAddr',
  data: function data() {
    return {
      addrInfo: {
        ca_city: "",
        ca_county: "",
        ca_if_default: "0",
        ca_mobile: "",
        ca_name: "",
        ca_phone: "",
        ca_province: "",
        ca_street: ""
      },
      isNew: false
    };
  },
  mounted: function mounted() {
    //获取数据
    if (this.$route.query.addrId) {
      this.getDetail();
    } else {
      this.isNew = true;
    }
    //获取焦点时移到页面可见区域
    $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
      var dom = e.target;
      setTimeout(function () {
        dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
      }, 200);
    });
  },

  methods: {
    deleteAddr: function deleteAddr() {
      var that = this;
      this.$messagebox.confirm('确定删除这条数据？', '温馨提示', { callback: function callback(type) {
          if (type == 'confirm') {
            that.$cHttp.post('cusaddrs/delete', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              ca_id: that.$route.query.addrId
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that.$router.go(-1);
              } else {
                that.$toast('删除失败');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    saveAddr: function saveAddr() {
      var _this = this;

      // todo 表单验证
      if (this.$route.query.addrId) {
        this.$cHttp.post('cusaddrs/edit', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey,
          user_id: this.$store.state.userInfo.user_id
        }, this.addrInfo)).then(function (res) {
          console.log(res);
          if (res.status && res.status == 1) {
            if (_this.$route.query.isSubSelect == 1) {
              _this.$router.go(-2);
              _this.$store.commit('setSelectedAddrData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.addrInfo));
            } else {
              _this.$router.go(-1);
            }
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      } else {
        this.$cHttp.post('cusaddrs/add', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey,
          user_id: this.$store.state.userInfo.user_id
        }, this.addrInfo)).then(function (res) {
          console.log(res);
          if (res.status && res.status == 1) {
            if (_this.$route.query.isSubSelect == 1) {
              _this.$router.go(-2);
              _this.$store.commit('setSelectedAddrData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.addrInfo));
            } else {
              _this.$router.go(-1);
            }
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      }
    },
    setDefault: function setDefault() {
      this.addrInfo.ca_if_default = this.addrInfo.ca_if_default == 1 ? 0 : 1;
    },
    showAddr: function showAddr(type, parent) {
      this.$refs.addrSelector.showAddr(type, parent);
    },
    endSelectAddr: function endSelectAddr(vals) {
      this.addrInfo.ca_province = vals[0];
      this.addrInfo.ca_city = vals[1];
      this.addrInfo.ca_county = vals[2];
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.$cHttp.post('cusaddrs/detail', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        ca_id: this.$route.query.addrId
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this2.addrInfo = res.data;
        } else {
          _this2.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this2.$toast(msg);
      });
    }
  },
  components: {
    AddrSelector: __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__["a" /* default */]
  }
});

/***/ }),

/***/ "Varj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VhsQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addrList_vue__ = __webpack_require__("sfsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6600bd84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addrList_vue__ = __webpack_require__("Ln+A");
function injectStyle (ssrContext) {
  __webpack_require__("5Si1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6600bd84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addrList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6600bd84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addrList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WTKX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cancel-icon.cbb827c.png";

/***/ }),

/***/ "WTi+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "editBasicInfo",
  data: function data() {
    return {
      basicInfo: {
        cus_name: '',
        cus_password: '',
        cus_mobile: '',
        cus_phone: '',
        cus_fax: ''
      },
      setPassword: false,
      oldPassword: '',
      rePassword: ''
    };
  },
  mounted: function mounted() {
    this.basicInfo.cus_name = this.$store.state.userInfo.user_name;
    this.basicInfo.cus_mobile = this.$store.state.userInfo.cus_mobile;
    this.basicInfo.cus_phone = this.$store.state.userInfo.cus_phone;
    this.basicInfo.cus_fax = this.$store.state.userInfo.cus_fax;
    //获取焦点时移到页面可见区域
    $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
      var dom = e.target;
      setTimeout(function () {
        dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
      }, 200);
    });
  },

  methods: {
    switchPassword: function switchPassword() {
      this.setPassword = !this.setPassword;
    },
    saveBasicInfo: function saveBasicInfo() {
      var _this = this;

      //表单验证
      if (this.setPassword) {
        if (!this.oldPassword) {
          this.$toast('请输入原密码');
          return;
        }
        if (!this.basicInfo.cus_password) {
          this.$toast('请输入新密码');
          return;
        }
        if (!this.rePassword) {
          this.$toast('请重新输入密码');
          return;
        }
        if (this.basicInfo.cus_password !== this.rePassword) {
          this.$toast('两次密码输入不一致');
          return;
        }
      } else {
        delete this.basicInfo.cus_password;
      }
      if (!this.basicInfo.cus_name) {
        this.$toast('请输入姓名');
        return;
      }
      if (!this.basicInfo.cus_mobile) {
        this.$toast('请输入手机号码');
        return;
      } else if (!/^1[34578]\d{9}$/.test(this.basicInfo.cus_mobile)) {
        this.$toast('请输入正确的手机号');
        return;
      }
      //提交数据
      this.$cHttp.post('customers/profile', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        old_password: this.oldPassword
      }, this.basicInfo)).then(function (res) {
        console.log(res);
        if (res.status == 1) {
          _this.$toast('修改成功！');
          //更新缓存的用户信息
          var curUserInfo = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.$store.state.userInfo));
          curUserInfo.user_name = _this.basicInfo.cus_name;
          curUserInfo.cus_mobile = _this.basicInfo.cus_mobile;
          curUserInfo.cus_phone = _this.basicInfo.cus_phone;
          curUserInfo.cus_fax = _this.basicInfo.cus_fax;
          _this.$store.commit('setUserInfo', curUserInfo);
        } else {
          _this.$toast(res.error_msg);
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    }
  }
});

/***/ }),

/***/ "Xejd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XkmV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACmklEQVRoQ+1ZwXHUQBDsjgA/+QERABHgiwCIADsCuAiwI+CcAURgiAA7AuwM7B9P8+M3VKt2VHNrSazuhCVR2qqrq9KtdqenZ2d75oiZD87cfiwAxmZwiwEzewHg0dBGkbwcek1frwJgZkcAPgE4+FcbAdiQXA+9PpPXfwy9cMt6b0l+HXIvATgB8HHIRTvWOiWp/QYbC4CerlwYyB22hNC+IWRmrzrWuCZ517XHqAyYmdK3Ls+uobR73AZkNABmdgjgeyGDFyRXTXPnAkC2n5H8MJlD3MLALYCbZKRkzfPMYIXS5/hsagw8I+kApNE2AN4Hg3WgVySvajE3lpRoYoDkvfrEzHSIXwcQAvjSD/WkGGgBoFC6yMKpPtSTB5Dk/lMACptYq6xJbmYBIIHIVfMlycNJAQCwdYhjtmk40JMEoCxTZ5gsherii2OSAAov5mraAqCPt3xuXdD01EJNey0MLAz0kNOTCSFJAn00dLuqobbrqM+ANLa6cnMbNQCJJSm80p7odfKcLh0pxVyzD+GIbwDkWBdyTbZ9IXnkvVFNFJ1tvVH99iRZFlNh1CcqRraKjZ5IYndQmr8KtUxOq0ms55XzVDsU/T+Q6ZBaypqZalq/4htLvlIQZqYocCdVa5mZHKrCX+dFo1Kgcc1SAG8AnIcXvdURGdurcWtmYu9d2EOA3HB/fE/sFQFIVOYbREdU8Vjq7aZ5ydsScs5CPq2xLVkMIIHIa1Q93tt4t9TM5HE5Kja7fgE4yUPH34mHOBbPXc5U2Di1ormzc7YjK49TQvkN4CcAfefjjuSZA8gL5x33ffDX1g5AqamrR/nglhVuePrfAJirnFjVWShlgDzvFjI5yrQrNbd6pdFRzPzLpguAsVmZPQN/AGVJe+QUp0hPAAAAAElFTkSuQmCC"

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_searchIndex_searchIndex__ = __webpack_require__("LTKR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_goodsList_goodsList__ = __webpack_require__("R6pA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_goodsDetail_goodsDetail__ = __webpack_require__("RAdM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shopBag_shopBag__ = __webpack_require__("G/wF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_orderList_orderList__ = __webpack_require__("CNfH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_userCenter_userCenter__ = __webpack_require__("zoya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_submitOrder_submitOrder__ = __webpack_require__("mTGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_addrList_addrList__ = __webpack_require__("VhsQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_editAddr_editAddr__ = __webpack_require__("87jZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_invoiceAddrList_invoiceAddrList__ = __webpack_require__("84YD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_invoiceEditAddr_invoiceEditAddr__ = __webpack_require__("k63h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_invoiceList_invoiceList__ = __webpack_require__("z4yg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_editInvoice_editInvoice__ = __webpack_require__("wlhD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_payInfo_payInfo__ = __webpack_require__("avVC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_orderDetail_orderDetail__ = __webpack_require__("tozh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_packageDetail_packageDetail__ = __webpack_require__("2f7Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_login_login__ = __webpack_require__("EV1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_login_register__ = __webpack_require__("5zCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_login_editBasicInfo__ = __webpack_require__("k3ny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_login_serverItem__ = __webpack_require__("dMDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_packageList_packageList__ = __webpack_require__("zAZr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_prepay_prepay__ = __webpack_require__("LBiS");

























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'SearchIndex',
    component: __WEBPACK_IMPORTED_MODULE_2__components_searchIndex_searchIndex__["a" /* default */],
    meta: {
      pageBelong: 'GoodsSearch'
    }
  }, {
    path: '/SearchIndex',
    name: 'SearchIndex',
    component: __WEBPACK_IMPORTED_MODULE_2__components_searchIndex_searchIndex__["a" /* default */],
    meta: {
      pageBelong: 'GoodsSearch'
    }
  }, {
    path: '/GoodsList/:keyword',
    name: 'GoodsList',
    component: __WEBPACK_IMPORTED_MODULE_3__components_goodsList_goodsList__["a" /* default */],
    meta: {
      pageBelong: 'GoodsSearch'
    }
  }, {
    path: '/GoodsList',
    name: 'GoodsList',
    component: __WEBPACK_IMPORTED_MODULE_3__components_goodsList_goodsList__["a" /* default */],
    meta: {
      pageBelong: 'GoodsSearch'
    }
  }, {
    path: '/GoodsDetail/:goodsId',
    name: 'GoodsDetail',
    component: __WEBPACK_IMPORTED_MODULE_4__components_goodsDetail_goodsDetail__["a" /* default */],
    meta: {
      pageBelong: 'GoodsSearch'
    }
  }, {
    path: '/ShopBag',
    name: 'ShopBag',
    component: __WEBPACK_IMPORTED_MODULE_5__components_shopBag_shopBag__["a" /* default */],
    meta: {
      pageBelong: 'ShopBag'
    }
  }, {
    path: '/SubmitOrder',
    name: 'SubmitOrder',
    component: __WEBPACK_IMPORTED_MODULE_8__components_submitOrder_submitOrder__["a" /* default */],
    meta: {
      pageBelong: 'ShopBag'
    }
  }, {
    path: '/OrderList',
    name: 'OrderList',
    component: __WEBPACK_IMPORTED_MODULE_6__components_orderList_orderList__["a" /* default */],
    meta: {
      pageBelong: 'OrderList'
    }
  }, {
    path: '/UserCenter',
    name: 'UserCenter',
    component: __WEBPACK_IMPORTED_MODULE_7__components_userCenter_userCenter__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/AddrList',
    name: 'AddrList',
    component: __WEBPACK_IMPORTED_MODULE_9__components_addrList_addrList__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/AddrList/:isSelect',
    name: 'AddrList',
    component: __WEBPACK_IMPORTED_MODULE_9__components_addrList_addrList__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/EditAddr',
    name: 'EditAddr',
    component: __WEBPACK_IMPORTED_MODULE_10__components_editAddr_editAddr__["a" /* default */],
    meta: {
      pageBelong: 'EditAddr'
    }
  }, {
    path: '/InvoiceAddrList',
    name: 'InvoiceAddrList',
    component: __WEBPACK_IMPORTED_MODULE_11__components_invoiceAddrList_invoiceAddrList__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/InvoiceAddrList/:isSelect',
    name: 'InvoiceAddrList',
    component: __WEBPACK_IMPORTED_MODULE_11__components_invoiceAddrList_invoiceAddrList__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/InvoiceEditAddr',
    name: 'InvoiceEditAddr',
    component: __WEBPACK_IMPORTED_MODULE_12__components_invoiceEditAddr_invoiceEditAddr__["a" /* default */],
    meta: {
      pageBelong: 'InvoiceEditAddr'
    }
  }, {
    path: '/InvoiceList',
    name: 'InvoiceList',
    component: __WEBPACK_IMPORTED_MODULE_13__components_invoiceList_invoiceList__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/InvoiceList/:isSelect',
    name: 'InvoiceList',
    component: __WEBPACK_IMPORTED_MODULE_13__components_invoiceList_invoiceList__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/EditInvoice',
    name: 'EditInvoice',
    component: __WEBPACK_IMPORTED_MODULE_14__components_editInvoice_editInvoice__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/PayInfo',
    name: 'PayInfo',
    component: __WEBPACK_IMPORTED_MODULE_15__components_payInfo_payInfo__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/OrderDetail/:orderId',
    name: 'OrderDetail',
    component: __WEBPACK_IMPORTED_MODULE_16__components_orderDetail_orderDetail__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/Login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_18__components_login_login__["a" /* default */],
    meta: {
      pageBelong: ''
    }
  }, {
    path: '/Register',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_19__components_login_register__["a" /* default */],
    meta: {
      pageBelong: ''
    }
  }, {
    path: '/EditBasicInfo',
    name: 'EditBasicInfo',
    component: __WEBPACK_IMPORTED_MODULE_20__components_login_editBasicInfo__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/ServerItem',
    name: 'ServerItem',
    component: __WEBPACK_IMPORTED_MODULE_21__components_login_serverItem__["a" /* default */],
    meta: {
      pageBelong: ''
    }
  }, {
    path: '/PackageList',
    name: 'PackageList',
    component: __WEBPACK_IMPORTED_MODULE_22__components_packageList_packageList__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/PackageDetail/:packageId',
    name: 'PackageDetail',
    component: __WEBPACK_IMPORTED_MODULE_17__components_packageDetail_packageDetail__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/Prepay',
    name: 'Prepay',
    component: __WEBPACK_IMPORTED_MODULE_23__components_prepay_prepay__["a" /* default */],
    meta: {
      pageBelong: 'UserCenter'
    }
  }, {
    path: '/*',
    name: 'SearchIndex',
    component: __WEBPACK_IMPORTED_MODULE_2__components_searchIndex_searchIndex__["a" /* default */],
    meta: {
      pageBelong: 'SearchIndex'
    }
  }]
}));

/***/ }),

/***/ "ZPNk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchBlock_vue__ = __webpack_require__("3UAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52fe075c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchBlock_vue__ = __webpack_require__("QzEL");
function injectStyle (ssrContext) {
  __webpack_require__("eZWv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52fe075c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52fe075c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zh0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_scroll_scroll__ = __webpack_require__("mnFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_orderItem_orderItem__ = __webpack_require__("PsGa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_checkItem_checkItem__ = __webpack_require__("VDv/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shopBag',
  data: function data() {
    return {
      keyWord: '',
      curPage: 0,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: false,
      listenScroll: true,
      probeType: 3
    };
  },

  computed: {
    totalPrice: function totalPrice() {
      var _totalPrice = 0;
      for (var i = 0; i < this.selectedGoods.length; i++) {
        _totalPrice += this.selectedGoods[i].price * this.selectedGoods[i].num;
      }
      return _totalPrice;
    },
    selectAll: function selectAll() {
      var isAll = true;
      for (var i = 0; i < this.data.length; i++) {
        if (this.data[i].if_checked == "0") {
          isAll = false;
          break;
        }
      }
      return isAll;
    },
    selectedGoods: function selectedGoods() {
      var selectedArr = [];
      for (var i = 0; i < this.data.length; i++) {
        if (this.data[i].if_checked == "1") {
          selectedArr.push(this.data[i]);
        }
      }
      return selectedArr;
    }
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this.keyWord = this.$route.params.keyword;
    this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
    this.probeType = 3;
    this.listenScroll = true;
    this.touch = {};

    this._getData(true);
  },

  methods: {
    searchSub: function searchSub(keyWord) {
      this.$router.push({ path: '/GoodsList/' + keyWord });
    },
    toPay: function toPay() {
      if (!this.totalPrice) {
        this.$messagebox.alert('温馨提示', '请选择需要结算的商品');
        return;
      }
      //清除之前存储的发票地址等信息
      this.$store.commit('setSelectedAddrData', {});
      this.$store.commit('setSelectedInvoiceAddrData', {});
      this.$store.commit('setSelectedInvoiceData', {});
      this.$router.push({ path: '/SubmitOrder' });
    },
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },
    scroll: function scroll(scrollPos, maxY) {
      if (scrollPos.y > 30) {
        this.pullDownMsg = '释放刷新';
      }
      if (this.hasMore) {
        if (scrollPos.y <= maxY - 40 && this.hasMore) {
          this.pullUpMsg = '释放加载更多';
        }
      } else {
        this.pullUpMsg = '';
      }
    },
    scrollToEnd: function scrollToEnd() {
      if (this.hasMore) {
        this._getData();
      }
    },
    scrollToTop: function scrollToTop() {
      //this.hasMore=true;
      this.curPage = 0;
      this._getData(true);
    },
    toDetail: function toDetail(item) {
      //this.$router.push({path:'/GoodsDetail/'+item.id})
    },
    selectItem: function selectItem(index) {
      //修改选中状态
      var that = this;
      that.$cHttp.post('shopcart/update', {
        partner: that.$systemConfig.partner,
        apikey: that.$systemConfig.apikey,
        user_id: that.$store.state.userInfo.user_id,
        id: that.data[index].id,
        if_checked: that.data[index].if_checked == "1" ? "0" : "1",
        num: that.data[index].num
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          //修改购物车数量
          that.$store.commit('setShopCount', res.data.total_num);
          that.data = res.data.items;
        } else {}
      }).catch(function (msg) {
        that.$toast(msg);
      });
    },
    selectAllClick: function selectAllClick() {

      //全选
      var that = this;
      that.$cHttp.post('shopcart/checkall', {
        partner: that.$systemConfig.partner,
        apikey: that.$systemConfig.apikey,
        user_id: that.$store.state.userInfo.user_id,
        if_checked: this.selectAll ? "0" : "1"
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          //修改购物车数量
          that.$store.commit('setShopCount', res.data.total_num);
          that.data = res.data.items;
        } else {}
      }).catch(function (msg) {
        that.$toast(msg);
      });
    },
    changeItemNum: function changeItemNum(index, num) {
      //修改数量
      var that = this;
      that.$cHttp.post('shopcart/update', {
        partner: that.$systemConfig.partner,
        apikey: that.$systemConfig.apikey,
        user_id: that.$store.state.userInfo.user_id,
        id: that.data[index].id,
        if_checked: that.data[index].if_checked,
        num: num
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          //修改购物车数量
          that.$store.commit('setShopCount', res.data.total_num);
          that.data = res.data.items;
        } else {}
      }).catch(function (msg) {
        that.$toast(msg);
      });
    },
    deleteItems: function deleteItems() {
      var that = this;
      if (!this.selectedGoods.length) {
        this.$messagebox.alert('请选择要删除的商品', '温馨提示');
        return;
      }
      if (this.selectedGoods.length > 1) {
        this.$messagebox.alert('只能单个删除', '温馨提示');
        return;
      }
      this.$messagebox.confirm('确定删除选中商品？', '温馨提示', { callback: function callback(type) {
          if (type == 'confirm') {
            //删除选中数据 然后刷新列表
            that.$cHttp.post('shopcart/delete', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              user_id: that.$store.state.userInfo.user_id,
              id: that.selectedGoods[0].id
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that.$toast("删除成功！");
                //修改购物车数量
                that.$store.commit('setShopCount', res.data.total_num);
                that.data = res.data.items;
              } else {
                that.$toast('暂无数据');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    deleteAll: function deleteAll() {
      var that = this;
      this.$messagebox.confirm('确定删除所有商品？', '温馨提示', { callback: function callback(type) {
          console.log(type);
          if (type == 'confirm') {
            //删除选中数据 然后刷新列表
            that.$cHttp.post('shopcart/clear', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              user_id: that.$store.state.userInfo.user_id
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that.$toast("删除成功！");
                //修改购物车数量
                that.$store.commit('setShopCount', res.data.total_num);
                that.data = res.data.items;
              } else {
                that.$toast('暂无数据');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    _getData: function _getData(clear) {
      var _this = this;

      if (!this.$store.state.userInfo.user_id) {
        //先登录
        this.$router.push('/Login?backRoute=' + this.$route.path);
        return;
      }
      this.$cHttp.post('shopcart/index', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id
      }).then(function (res) {
        if (res.status && res.status == 1) {
          console.log(res);
          _this.data = res.data.items;
          //修改购物车数量
          _this.$store.commit('setShopCount', res.data.total_num);
        } else {
          _this.$toast(res.error_msg);
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });

      /*if(clear){
      	this.data=tempListData;
      }else{
      	this.data=this.data.concat(tempListData);
      }
      //假设总共只有3页
      if(this.curPage==3){
      	this.hasMore=false;
      	this.pullUpMsg='没有更多数据了';
      }
      this.curPage++;*/
    }
  },
  components: {
    SearchBlock: __WEBPACK_IMPORTED_MODULE_3_basic_searchBlock_searchBlock__["a" /* default */], Scroll: __WEBPACK_IMPORTED_MODULE_0_basic_scroll_scroll__["a" /* default */], OrderItem: __WEBPACK_IMPORTED_MODULE_1_basic_orderItem_orderItem__["a" /* default */], CheckItem: __WEBPACK_IMPORTED_MODULE_2_basic_checkItem_checkItem__["a" /* default */]
  }
});

/***/ }),

/***/ "ZpB4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aQxo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "amdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"addr-info",on:{"click":_vm.selectAddr}},[_c('h3',{staticClass:"block-title"},[_vm._v("收货地址")]),_vm._v(" "),(!_vm.$store.state.selectedAddrData.ca_name)?_c('div',{staticClass:"empty-info"},[_vm._v("请选择地址")]):_c('div',[_c('h3',{staticClass:"addr-user"},[_c('label',{staticClass:"name"},[_vm._v(_vm._s(_vm.$store.state.selectedAddrData.ca_name))]),_c('span',{staticClass:"telNum"},[_vm._v(_vm._s(_vm.$store.state.selectedAddrData.ca_mobile))])]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedAddrData.ca_province))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedAddrData.ca_city))]),_vm._v(" "),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedAddrData.ca_county))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedAddrData.ca_street))])])])]),_vm._v(" "),_c('div',{staticClass:"addr-info",on:{"click":_vm.selectInvoiceAddr}},[_c('h3',{staticClass:"block-title"},[_vm._v("收票地址")]),_vm._v(" "),(!_vm.$store.state.selectedInvoiceAddrData.cia_name)?_c('div',{staticClass:"empty-info"},[_vm._v("请选择地址")]):_c('div',[_c('h3',{staticClass:"addr-user"},[_c('label',{staticClass:"name"},[_vm._v(_vm._s(_vm.$store.state.selectedInvoiceAddrData.cia_name))]),_c('span',{staticClass:"telNum"},[_vm._v(_vm._s(_vm.$store.state.selectedInvoiceAddrData.cia_mobile))])]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedInvoiceAddrData.cia_province))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedInvoiceAddrData.cia_city))]),_vm._v(" "),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedInvoiceAddrData.cia_county))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.$store.state.selectedInvoiceAddrData.cia_street))])])])]),_vm._v(" "),_c('div',{staticClass:"need-invoice-group"},[_c('p',{on:{"click":function($event){_vm.needInvoiceSwitch(true)}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.needInvoice}}),_vm._v("开票")]),_vm._v(" "),_c('p',{on:{"click":function($event){_vm.needInvoiceSwitch(false)}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':!_vm.needInvoice}}),_vm._v("不开票")])]),_vm._v(" "),(_vm.needInvoice)?_c('div',{staticClass:"invoice-info",on:{"click":_vm.selectInvoice}},[_c('h3',{staticClass:"invoice-title"},[_vm._v("发票信息")]),_vm._v(" "),(!_vm.$store.state.selectedInvoiceData.ci_id)?_c('div',{staticClass:"empty-info"},[_vm._v("请选择发票")]):_c('div',{staticClass:"invoice-item"},[_c('i',{staticClass:"invoice-type-icon"},[_vm._v(_vm._s(['','普','专'][_vm.$store.state.selectedInvoiceData.ci_type]))]),_vm._v(" "),_c('h3',{staticClass:"invoice-info-item"},[_c('label',{staticClass:"value"},[(_vm.$store.state.selectedInvoiceData.ci_type==2)?_c('span',{staticClass:"name"},[_vm._v("抬头：")]):_vm._e(),_vm._v(_vm._s(_vm.$store.state.selectedInvoiceData.ci_title))]),_vm._v(" "),_c('label',{staticClass:"value"},[(_vm.$store.state.selectedInvoiceData.ci_type==2)?_c('span',{staticClass:"name"},[_vm._v("税号：")]):_vm._e(),_vm._v(_vm._s(_vm.$store.state.selectedInvoiceData.ci_vatno))])]),_vm._v(" "),(_vm.$store.state.selectedInvoiceData.ci_type=='2')?_c('h3',{staticClass:"invoice-info-item"},[_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("银行：")]),_vm._v(_vm._s(_vm.$store.state.selectedInvoiceData.ci_bank))]),_vm._v(" "),_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("账号：")]),_vm._v(_vm._s(_vm.$store.state.selectedInvoiceData.ci_bknum))])]):_vm._e(),_vm._v(" "),(_vm.$store.state.selectedInvoiceData.ci_type=='2')?_c('h3',{staticClass:"invoice-info-item"},[_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("地址：")]),_vm._v(_vm._s(_vm.$store.state.selectedInvoiceData.ci_addr))]),_vm._v(" "),_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("电话：")]),_vm._v(_vm._s(_vm.$store.state.selectedInvoiceData.ci_phone))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"other-info"},[_c('mt-field',{staticClass:"inputcontent",attrs:{"type":"textarea","placeholder":"请输入订单备注"},model:{value:(_vm.extralInfo),callback:function ($$v) {_vm.extralInfo=$$v},expression:"extralInfo"}})],1),_vm._v(" "),_c('ul',{staticClass:"order-listbox"},_vm._l((_vm.orderData.goodsList),function(item,index){return _c('li',{staticClass:"order-list-item",on:{"click":function($event){_vm.toDetail(item)}}},[_c('order-item',{attrs:{"goodsData":item,"index":index,"readOnly":true}})],1)})),_vm._v(" "),_c('div',{staticClass:"price-info"},[_c('p',{staticClass:"price-group"},[_c('label',[_vm._v("运费")]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(_vm.orderData.priceData.freight))])])]),_vm._v(" "),_c('div',{staticClass:"submit-bar"},[_c('p',{staticClass:"total-price"},[_vm._v("订单金额:"),_c('span',[_vm._v("￥"+_vm._s(_vm.orderData.totalPrice))])]),_vm._v(" "),_c('button',{staticClass:"submit-btn",attrs:{"id":"toPay"},on:{"click":_vm.toPay}},[_vm._v("提交订单")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "avVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payInfo_vue__ = __webpack_require__("CWQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7de6c592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payInfo_vue__ = __webpack_require__("xuVI");
function injectStyle (ssrContext) {
  __webpack_require__("aQxo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7de6c592"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7de6c592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "broi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: '',
	data: function data() {
		return {
			login_text: '',
			username: '',
			password: ''
		};
	},
	mounted: function mounted() {
		if (this.ifWeChat()) {
			this.login_text = '立即绑定';
		} else {
			this.login_text = '登&nbsp;&nbsp;陆';
		}
	},

	methods: {
		loginSub: function loginSub() {
			var _this = this;

			if (!this.username) {
				this.$toast('请输入登录邮箱');
				return;
			}
			if (!this.password) {
				this.$toast('请输入密码');
				return;
			}
			if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.username)) {
				this.$toast('请输入正确格式的邮箱');
				return;
			}
			//测试账号 aloneshen2003@163.com/123456
			console.log(this.$store.state.wxOpenId);
			this.$cHttp.post('customers/login', {
				partner: this.$systemConfig.partner,
				apikey: this.$systemConfig.apikey,
				cus_email: this.username,
				cus_password: this.password,
				cus_wxopenid: this.$store.state.wxOpenId
			}).then(function (res) {
				if (res.status && res.status == 1) {
					//存储用户信息并跳转页面
					_this.$store.commit('setUserInfo', res.data);
					_this.$store.commit('setWxOpenId', res.data.cus_wxopenid);
					if (res.data.cus_wxopenid != '') {
						_this.$store.commit('setWxState', '1');
					}
					//查询购物车信息
					_this.$cHttp.post('shopcart/index', {
						partner: _this.$systemConfig.partner,
						apikey: _this.$systemConfig.apikey,
						user_id: _this.$store.state.userInfo.user_id
					}).then(function (res) {
						if (res.status && res.status == 1) {
							//修改购物车数量
							_this.$store.commit('setShopCount', res.data.total_num);
						} else {
							_this.$toast(res.error_msg);
						}
					}).catch(function (msg) {
						_this.$toast(msg);
					});
					if (_this.$route.query.backRoute) {
						_this.$router.replace({ path: _this.$route.query.backRoute });
					} else {
						_this.$router.replace({ path: '/goodsList' });
					}
				} else {
					_this.$toast(res.error_msg);
				}
			}).catch(function (msg) {
				_this.$toast(msg);
			});
			console.log('login');
		},
		forgetPW: function forgetPW() {
			console.log('忘记密码');
		},
		toRegister: function toRegister() {
			this.$router.push({ path: '/Register' });
		},
		ifWeChat: function ifWeChat() {
			var ua = window.navigator.userAgent.toLowerCase();
			return ua.match(/MicroMessenger/i) == 'micromessenger';
		}
	},
	components: {}
});

/***/ }),

/***/ "cnoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {};
  },

  methods: {
    goBack: function goBack() {
      this.$router.back();
    }
  },
  components: {}
});

/***/ }),

/***/ "dMDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_serverItem_vue__ = __webpack_require__("cnoP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5dbbf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_serverItem_vue__ = __webpack_require__("1aI6");
function injectStyle (ssrContext) {
  __webpack_require__("Varj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e5dbbf7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_serverItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5dbbf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_serverItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dVZy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f1Vh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fcOn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g5XB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsItem_vue__ = __webpack_require__("VR2q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b847e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_goodsItem_vue__ = __webpack_require__("th6g");
function injectStyle (ssrContext) {
  __webpack_require__("Sf5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77b847e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_goodsItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b847e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_goodsItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gIQV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLvk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hmnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('footer-bar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iT5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('transition',{attrs:{"name":"bounce2"}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.provinceVisible),expression:"provinceVisible"}],staticClass:"area-select-wapper",on:{"click":function($event){_vm.provinceVisible=false;}}},[_c('div',{staticClass:"area-select-innerBox",on:{"click":function($event){$event.stopPropagation();}}},[_c('h2',{staticClass:"area-select-title"},[_vm._v("选择省"),_c('i',{staticClass:"mintui mintui-field-error",on:{"click":function($event){_vm.provinceVisible=false;}}})]),_vm._v(" "),_c('div',{staticClass:"area-list-box"},[_c('ul',{staticClass:"area-list"},_vm._l((_vm.myAddressProvinceData),function(item){return _c('li',{staticClass:"area-list-item",on:{"click":function($event){_vm.getListItem('myAddressCityData',item)}}},[_c('label',{staticClass:"area-item-name"},[_vm._v(_vm._s(item.value))])])}))])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce2"}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.cityVisible),expression:"cityVisible"}],staticClass:"area-select-wapper",on:{"click":function($event){_vm.cityVisible=false;}}},[_c('div',{staticClass:"area-select-innerBox",on:{"click":function($event){$event.stopPropagation();}}},[_c('h2',{staticClass:"area-select-title"},[_vm._v("选择市"),_c('i',{staticClass:"mintui mintui-field-error",on:{"click":function($event){_vm.cityVisible=false;}}})]),_vm._v(" "),_c('div',{staticClass:"area-list-box"},[_c('ul',{staticClass:"area-list"},_vm._l((_vm.myAddressCityData),function(item){return _c('li',{staticClass:"area-list-item",on:{"click":function($event){_vm.getListItem('myAddressCountyData',item)}}},[_c('label',{staticClass:"area-item-name"},[_vm._v(_vm._s(item.value))])])}))])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce2"}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.countyVisible),expression:"countyVisible"}],staticClass:"area-select-wapper",on:{"click":function($event){_vm.countyVisible=false;}}},[_c('div',{staticClass:"area-select-innerBox",on:{"click":function($event){$event.stopPropagation();}}},[_c('h2',{staticClass:"area-select-title"},[_vm._v("选择区/县"),_c('i',{staticClass:"mintui mintui-field-error",on:{"click":function($event){_vm.countyVisible=false;}}})]),_vm._v(" "),_c('div',{staticClass:"area-list-box"},[_c('ul',{staticClass:"area-list"},_vm._l((_vm.myAddressCountyData),function(item){return _c('li',{staticClass:"area-list-item",on:{"click":function($event){_vm.getListItem('lastLevel',item)}}},[_c('label',{staticClass:"area-item-name"},[_vm._v(_vm._s(item.value))])])}))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iTzp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iz09":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jJdx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jfg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editAddr',
  props: {
    curProvince: {
      type: String,
      default: ''
    },
    curCity: {
      type: String,
      default: ''
    },
    curCounty: {
      type: String,
      default: ''
    }
    /*curVillage: {
      type: String,
      default: ''
    },*/
  },
  data: function data() {
    return {
      myAddressProvinceData: [],
      myAddressCityData: [],
      myAddressCountyData: [],
      // myAddressVillageData:[],
      provinceVisible: false,
      cityVisible: false,
      countyVisible: false,
      // villageVisible:false,
      myProvince: '',
      myCity: '',
      myCounty: ''
      // myVillage:'',
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {//vue里面全部加载好了再执行的函数  （类似于setTimeout）

    });
  },

  methods: {
    showAddr: function showAddr(type, parent) {
      this.myProvince = this.curProvince;
      this.myCity = this.curCity;
      this.myCounty = this.curCounty;
      if (parent) {
        if (type == 'city') {
          //选择市
          this.getListItem('myAddressCityData', { id: parent });
        } else if (type == 'county') {
          //选择县
          this.getListItem('myAddressCountyData', { id: parent });
        } else {
          this.getListItem();
        }
      } else {
        //没有父级id
        this.getListItem();
      }
    },
    getListItem: function getListItem(dataType, item) {
      var _this = this;

      //显示相应的选择项
      if (!dataType) {
        this.provinceVisible = true;
      } else if (dataType == 'myAddressCityData') {
        this.myProvince = item.id;
        if (this.myProvince) {
          this.cityVisible = true;
        } else {
          this.provinceVisible = true;
        }
      } else if (dataType == 'myAddressCountyData') {
        this.myCity = item.id;
        if (this.myCity) {
          this.countyVisible = true;
        } else if (this.myProvince) {
          this.cityVisible = true;
        } else {
          this.provinceVisible = true;
        }
      } else if (dataType == 'lastLevel') {
        this.myCounty = item.id;
        if (this.myCounty) {
          this.provinceVisible = false;
          this.countyVisible = false;
          this.cityVisible = false;
          this.$emit('endSelectAddr', [this.myProvince, this.myCity, this.myCounty]);
        } else if (this.myCity) {
          this.countyVisible = true;
        } else if (this.myProvince) {
          this.cityVisible = true;
        } else {
          this.provinceVisible = true;
        }
      }
      //获取城市参数
      if (dataType != 'lastLevel') {
        this.$cHttp.post('regions/index', {
          parent: item && item.id ? item.id : '1'
        }).then(function (res) {
          if (res.status && res.status == 1) {
            if (dataType) {
              _this[dataType] = res.data;
            } else {
              _this.myAddressProvinceData = res.data;
            }
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      }
    }
  },
  components: {}
});

/***/ }),

/***/ "joTY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k3ny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editBasicInfo_vue__ = __webpack_require__("WTi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff048a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editBasicInfo_vue__ = __webpack_require__("OFlu");
function injectStyle (ssrContext) {
  __webpack_require__("RYaw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ff048a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editBasicInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff048a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editBasicInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k63h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceEditAddr_vue__ = __webpack_require__("EPFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f749a76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceEditAddr_vue__ = __webpack_require__("rHvm");
function injectStyle (ssrContext) {
  __webpack_require__("s4rC")
  __webpack_require__("1tiE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f749a76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceEditAddr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f749a76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceEditAddr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l23d":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "lrMw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m5QD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_orderItem_orderItem__ = __webpack_require__("PsGa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "packageDetail",
  data: function data() {
    return {
      pakageInfo: {},
      orderStatusMap: ['未审核', '审核通过', '审核通过', '已取消'],
      orderTypeMap: ['未付款', '部分付款', '全额付款'],
      invoiceTypeMap: ['随货', '月开', '半月开', '不开票']
    };
  },
  mounted: function mounted() {
    this.getOrderDetail();
  },

  methods: {
    toDetail: function toDetail(item) {
      //this.$router.push({path:'/GoodsDetail/'+item.id})
    },
    getOrderDetail: function getOrderDetail() {
      var _this = this;

      this.$cHttp.post('dispatchs/detail', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        dp_id: this.$route.params.packageId
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this.pakageInfo = res.data;
        } else {
          _this.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    }
  },
  components: {
    OrderItem: __WEBPACK_IMPORTED_MODULE_0_basic_orderItem_orderItem__["a" /* default */]
  }
});

/***/ }),

/***/ "mGVq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADwElEQVRoQ71agVEVQQxNKlArUCqQDpQKhArUCtQK1ArECtQKgAqECpQKhA6kgjiPyTk3+5NssrefnWGG4f/L5m1e8pI9mPawROQZET1V04+J6C8R3THz79nb8QyD6vArInpJRMcdmwDxnYgumPlm6/6bAKjjH4nozaAjl0T0dguQIQAiAlrA8feDjrePISIfmBlUK60yAD31MyI6LO3U/zLodFLNkxIAEYHTP4kIEdjHQgRAqfOs8TSAovNXRAR+rxcSHAfwqOMcQBxlI5ECoJzHyUe0uSWiT0R0HnFZRFClkDsvAiAAcZDJiSwAcD4qj0jA02zY8T0RQeXCM15ELpn5qGezC0BEEHqcvrXuUPuz4W4NKC1RgZ479pEP+NxdGQBwHiDatcn5xZiCQL5Ykbhh5oNhAJ3TL9PGc6SzTxiFMAIiAo6+Mza+YmYrKvdfVa3Ac0vSo31A69BWpv+mRQRUeW3shefc/OsB+ENEaMzahTJnOiMiXwKFdhVXQWM/az3xKpILQLn5y+I+M5tCFkRsbQZl9sTyUkQQKSuh3QOLAHjV5wcz7zRvHR63/qJl2FFbEYGOoMdq12dmxmc7KwJQMpY8/cUBk9cqctCcvQLwTg85Eanr2imzPAZRdBN5JAIzAGA628mjhwJg8jEogxZ1PQp5eTeUA56xr8y8M8gUk9gUpyCJXTHr6QC6wlbiXXlPRsEVQRFB2bY63roOqKJ66hgJmfcMTGJOOLZEKRCyUPV7EfBoFLa6SidoxaLiGBchYO6kFURvvBfSKGDz5Y5nnZBmNXJagfDPkerjEKLBJtNO4yS/GR6URj8PgU576IGs9sStPou9LoBOFDaB6NxwYN4ITx++ZQF4UYCN8k2CHgryC22Dd8PRPf00AN2w1yrg81NmvogIrwmOhs2dJ4jolpmtNj7fzLXfLAgVIoJqg+TH7/iBM/iB0xnH0gUiRaEFTLHjHClI91oRTXut0SoA8BUn27ucGnUeiXtYuewtAdBcwHxq9eyjTq+fK18UlAEoCHAc7wNmrhJ1SjpgJDSohPnVUugRUGXqbAKwquPejV0VRLrqbEpiIxLe3FwBYF4SZA0M5cDauIj0BC7y5VrvVstvZjZTaKUNo6V1yt3q5ghsyIfuzXOGRlMAKAjMybhWzKxNvF9vMA2AgojGyWXfa2ae9oJwNgDkA5Lae2GR6vEzIZyWxEZpRbcJkWv7pSlJO1UHvJNy3rpMSdoHAaD5sJ7iyk1alkZTc8CgEyoT2uPR/6Xo4tgrgO7uE77wD7jsuEDQPpz1AAAAAElFTkSuQmCC"

/***/ }),

/***/ "mTGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitOrder_vue__ = __webpack_require__("w5BE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390dde52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submitOrder_vue__ = __webpack_require__("amdm");
function injectStyle (ssrContext) {
  __webpack_require__("uJ0d")
  __webpack_require__("RKUm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-390dde52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390dde52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submitOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mlVE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mnFd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_vue__ = __webpack_require__("FX7L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ad68f20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scroll_vue__ = __webpack_require__("jJdx");
function injectStyle (ssrContext) {
  __webpack_require__("vSvE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ad68f20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ad68f20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scroll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n6Xk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'footer',
	data: function data() {
		return {};
	},

	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		console.log($1111);
		//to.meta.keepAlive = true;  //
		next();
	},
	methods: {
		pageChange: function pageChange(path) {
			this.$router.push({ path: path });
		}
	},
	components: {}
});

/***/ }),

/***/ "nN3f":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAC+ElEQVRoQ+1Z7XEaMRDVSgWEEuIKciMVEFJBnApiVxA6CK4gUEGgAicVGBcgoXTgdOAUoNvM3gjmuA9OJwuOm0E/QVq9t7uS3u0CG/mAkeNnvQhkWTYBgA870oj4x1r7mmXZFACwrzO22+1zm81QW50ElFLfGGN3jLGsatQ598lau1FK9QZPtrTWQOSFEE8NgC1jbOWcW5OT2gi1EsiyLOOcPwLA+7bFJyZQbIuIrwBwr7X+1YSjkYCU8g4AfnaF8RwESul6b4xZVTHVCHjPPwHA5JIIeCxfqpGoEVBKUT5Ou8DT/+eMgE+nF2PMTRnbAQHyvhBiGwJ+CAKexEEqHRCQUi4AgG6doHHuCHhQa6013YrFqBLYAMDHIPQDpJCPwLMxZp/ioyOwez9GG4ErgfL5GOgQFxIkaQpJKTd5ns/JKOd87i+Cf4g4z/N8JYRYMMa++kO4pLmc85kxZn5EC7XeJckJVHdSSt065zZlEUZvDM2z1pJI249BCTDGiqfdg/juH7cHUqgkkznn9BvpqpnWek3/k7pFxBkALLTWy0EJeKX40iC1N4iYlfUUItI8VlG3FhHpG6NV8TblUbIUCn3wUs+7Ekjt0b72rhHo67HU868RSO3RvvauEejrsdTzYyPwGxEPdMwRYLflCt5FENhJ5xAwUkrSOj9C5sbMiY0A7bUJ3DCoLBNoqzbtLQRi90y6LooAIv5ljBWKsmkAAOn9d0mRthiLItB1BkLrqSkIRhHwer5WXC0Bog+XXro+lkwUgdjNTrFu1AToLBpj9pE+qMwppaiJ8PkUXktlExGPlhaDGhupwMTYQcQHKsfs1lbL6xMhBF2VZ7kOYwg4526stfvrvNbgkFJSYaookVzaQMSlMWZWxtXWI+tVZj8HUWrp5nk+rXYsGwlQUUoIQXf+RRzoNvDkuKN9Yv+6Ul1zqDNB9dVF+dBWo93Z6KYFVP7jnJPCpM5lreGdOIXom4N6w7atN9x5BhIDOqm5oAicFMEbjY+ewH8/tBZPTirlbgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "nf/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__ = __webpack_require__("mnFd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      keyWord: '',
      curPage: 1,
      pageSize: 10,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: true,
      listenScroll: true,
      probeType: 3,
      orderStatusMap: ['未审核', '审核通过', '审核通过', '已取消'],
      orderTypeMap: ['未付款', '部分付款', '全额付款']
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this._getData(true);
  },

  methods: {
    searchSub: function searchSub(keyWord) {
      this.$router.push({ path: '/GoodsList/' + keyWord });
    },
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },
    scroll: function scroll(scrollPos, maxY) {
      if (scrollPos.y > 30) {
        this.pullDownMsg = '释放刷新';
      }
      if (scrollPos.y <= maxY - 40 && this.hasMore) {
        this.pullUpMsg = '释放加载更多';
      }
    },
    scrollToEnd: function scrollToEnd() {
      if (this.hasMore) {
        this._getData();
      }
    },
    scrollToTop: function scrollToTop() {
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
    },
    toDetail: function toDetail(item) {
      this.$router.push({ path: '/PackageDetail/' + item.dp_id });
    },
    payOrder: function payOrder(item) {
      //先查支付信息  在跳支付页面
      this.$router.push({ path: '/PayInfo/' });
    },
    cancelOrder: function cancelOrder(item) {
      this.$toast('取消订单');
    },
    setListType: function setListType(type, status) {
      this.$store.commit('setCurOrderType', type);
      this.scrollToTop();
      this.$refs.listview.scrollTo(0, 0);
    },
    _getData: function _getData(clear) {
      var _this = this;

      this.$cHttp.post('dispatchs/index', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        page_pernum: this.pageSize,
        current_page: this.curPage
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          if (clear) {
            _this.data = res.data.rows;
          } else {
            _this.data = _this.data.concat(res.data.rows);
          }
          if (_this.curPage + 1 > res.data.total_page) {
            _this.hasMore = false;
            _this.pullUpMsg = '没有更多数据了';
          } else {
            _this.curPage++;
          }
          if (res.data.rows.length < 1) {
            _this.$toast('暂无数据');
          }
        } else {
          _this.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    }
  },
  components: {
    SearchBlock: __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__["a" /* default */], Scroll: __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__["a" /* default */]
  }
});

/***/ }),

/***/ "nybC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oBeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addrSelector_vue__ = __webpack_require__("jfg0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d632a50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addrSelector_vue__ = __webpack_require__("iT5P");
function injectStyle (ssrContext) {
  __webpack_require__("dVZy")
  __webpack_require__("RA9a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d632a50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addrSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d632a50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addrSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oJ4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {};
  },

  props: {
    itemChecked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickItem: function clickItem() {
      this.$emit('clickItem');
    }
  },
  components: {}
});

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        wxOpenId: '',
        wxState: '',
        userName: '',
        userInfo: {
            // user_id:'4314'
            // user_id:'1'
        },
        subOrderInfo: {},
        pageBelong: '',
        shopCount: 0,
        curOrderType: 'all',
        eidtAddrData: {
            ca_city: "",
            ca_county: "",
            ca_id: "",
            ca_if_default: "0",
            ca_mobile: "",
            ca_name: "",
            ca_phone: "",
            ca_province: "",
            ca_street: ""
        },
        selectedAddrData: {
            ca_city: "",
            ca_county: "",
            ca_id: "",
            ca_if_default: "0",
            ca_mobile: "",
            ca_name: "",
            ca_phone: "",
            ca_province: "",
            ca_street: ""
        },
        eidtInvoiceAddrData: {
            cia_city: "",
            cia_county: "",
            cia_id: "",
            cia_if_default: "0",
            cia_mobile: "",
            cia_name: "",
            cia_phone: "",
            cia_province: "",
            cia_street: ""
        },
        selectedInvoiceAddrData: {
            cia_city: "",
            cia_county: "",
            cia_id: "",
            cia_if_default: "0",
            cia_mobile: "",
            cia_name: "",
            cia_phone: "",
            cia_province: "",
            cia_street: ""
        },
        eidtInvoiceData: {
            ci_addr: "",
            ci_bank: "",
            ci_bknum: "",
            ci_id: "",
            ci_if_default: "1",
            ci_phone: "",
            ci_title: "",
            ci_type: "1",
            ci_vatno: ""
        },
        selectedInvoiceData: {
            ci_addr: "",
            ci_bank: "",
            ci_bknum: "",
            ci_id: "",
            ci_if_default: "1",
            ci_phone: "",
            ci_title: "",
            ci_type: "1",
            ci_vatno: ""
        }
    },
    mutations: {
        setWxOpenId: function setWxOpenId(state, wxOpenId) {
            state.wxOpenId = wxOpenId;
        },
        setWxState: function setWxState(state, wxState) {
            state.wxState = wxState;
        },
        setUserName: function setUserName(state, userName) {
            state.userName = userName;
        },
        setSubOrderInfo: function setSubOrderInfo(state, subOrderInfo) {
            state.subOrderInfo = subOrderInfo;
        },
        setUserInfo: function setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setPageBelong: function setPageBelong(state, pageBelong) {
            state.pageBelong = pageBelong;
        },
        setShopCount: function setShopCount(state, shopCount) {
            state.shopCount = shopCount;
        },
        setCurOrderType: function setCurOrderType(state, curOrderType) {
            state.curOrderType = curOrderType;
        },
        setEidtAddrData: function setEidtAddrData(state, eidtAddrData) {
            state.eidtAddrData = eidtAddrData;
        },
        setSelectedAddrData: function setSelectedAddrData(state, selectedAddrData) {
            state.selectedAddrData = selectedAddrData;
        },
        setEidtInvoiceAddrData: function setEidtInvoiceAddrData(state, eidtInvoiceAddrData) {
            state.eidtInvoiceAddrData = eidtInvoiceAddrData;
        },
        setSelectedInvoiceAddrData: function setSelectedInvoiceAddrData(state, selectedInvoiceAddrData) {
            state.selectedInvoiceAddrData = selectedInvoiceAddrData;
        },
        setEidtInvoiceData: function setEidtInvoiceData(state, eidtInvoiceData) {
            state.eidtInvoiceData = eidtInvoiceData;
        },
        setSelectedInvoiceData: function setSelectedInvoiceData(state, selectedInvoiceData) {
            state.selectedInvoiceData = selectedInvoiceData;
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "q/am":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qFRv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_orderItem_orderItem__ = __webpack_require__("PsGa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "orderDetail",
  data: function data() {
    return {
      orderInfo: {},
      orderStatusMap: ['未审核', '审核通过', '审核通过', '已取消'],
      orderTypeMap: ['未付款', '部分付款', '全额付款'],
      invoiceTypeMap: ['随货', '月开', '半月开', '不开票']
    };
  },
  mounted: function mounted() {
    this.getOrderDetail();
  },

  methods: {
    toDetail: function toDetail(item) {
      this.$router.push({ path: '/GoodsDetail/' + item.id });
    },
    getOrderDetail: function getOrderDetail() {
      var _this = this;

      this.$cHttp.post('orders/detail', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        so_id: this.$route.params.orderId
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this.orderInfo = res.data;
        } else {
          _this.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    }
  },
  components: {
    OrderItem: __WEBPACK_IMPORTED_MODULE_0_basic_orderItem_orderItem__["a" /* default */]
  }
});

/***/ }),

/***/ "qONS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r6k3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('form',{staticClass:"addr-form",attrs:{"name":"addrForm","action":"javascript:void(0)"}},[_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"姓名","placeholder":"请输入姓名"},model:{value:(_vm.addrInfo.cia_name),callback:function ($$v) {_vm.addrInfo.cia_name=$$v},expression:"addrInfo.cia_name"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"手机号","placeholder":"请输入手机号","type":"number"},model:{value:(_vm.addrInfo.cia_mobile),callback:function ($$v) {_vm.addrInfo.cia_mobile=$$v},expression:"addrInfo.cia_mobile"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"联系电话","placeholder":"请输入联系电话","type":"number"},model:{value:(_vm.addrInfo.cia_phone),callback:function ($$v) {_vm.addrInfo.cia_phone=$$v},expression:"addrInfo.cia_phone"}}),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showAddr('province')}}},[_c('mt-field',{staticClass:"required",attrs:{"label":"省","placeholder":"请选择省","readonly":true,"disableClear":true},model:{value:(_vm.addrInfo.cia_province),callback:function ($$v) {_vm.addrInfo.cia_province=$$v},expression:"addrInfo.cia_province"}})],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showAddr('city',_vm.addrInfo.cia_province)}}},[_c('mt-field',{staticClass:"required",attrs:{"label":"市","placeholder":"请选择市","readonly":true,"disableClear":true},model:{value:(_vm.addrInfo.cia_city),callback:function ($$v) {_vm.addrInfo.cia_city=$$v},expression:"addrInfo.cia_city"}})],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showAddr('county',_vm.addrInfo.cia_city)}}},[_c('mt-field',{staticClass:"required",attrs:{"label":"区/县","placeholder":"请选择区/县","readonly":true,"disableClear":true},model:{value:(_vm.addrInfo.cia_county),callback:function ($$v) {_vm.addrInfo.cia_county=$$v},expression:"addrInfo.cia_county"}})],1),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"详细地址","placeholder":"请输入详细地址","type":"textarea"},model:{value:(_vm.addrInfo.cia_street),callback:function ($$v) {_vm.addrInfo.cia_street=$$v},expression:"addrInfo.cia_street"}}),_vm._v(" "),_c('p',{staticClass:"set-default-group",on:{"click":_vm.setDefault}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.addrInfo.cia_if_default==1}}),_vm._v("设为默认地址")]),_vm._v(" "),_c('div',{staticClass:"opr-group"},[_c('mt-button',{attrs:{"size":"large","plain":""},on:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"btn-div"}),_vm._v(" "),(!_vm.isNew)?_c('mt-button',{attrs:{"size":"large","type":"danger","plain":""},on:{"click":_vm.deleteAddr}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-div"}),_vm._v(" "),_c('mt-button',{attrs:{"size":"large","type":"danger"},on:{"click":_vm.saveAddr}},[_vm._v("保存")])],1)],1),_vm._v(" "),_c('addr-selector',{ref:"addrSelector",attrs:{"curProvince":_vm.addrInfo.cia_province,"curCity":_vm.addrInfo.cia_city,"curCounty":_vm.addrInfo.cia_county},on:{"endSelectAddr":_vm.endSelectAddr}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rNgS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      headImgUrl: 'http://m.rhawn.cn/static/logo-icon.png',
      keyWord: '',
      orderNum: {
        toPay: 0,
        payed: 0,
        toCheck: 0,
        checked: 0
      },
      accountInfo: {
        toPayNum: 273232.82,
        cardNum: 1,
        grade: 1.23
      }
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    if (this.$store.state.userInfo.headImgUrl && this.$store.state.userInfo.headImgUrl != '') {
      this.headImgUrl = this.$store.state.userInfo.headImgUrl;
    }
    this.getPrepayInfo();
  },

  methods: {
    searchSub: function searchSub(keyWord) {
      this.$router.push({ path: '/GoodsList/' + keyWord });
    },
    setBasicInfo: function setBasicInfo() {
      this.$router.push({ path: '/EditBasicInfo' });
    },
    toPrepay: function toPrepay() {
      //跳转至我的预存款
      this.$router.push({ path: '/Prepay' });
    },
    toOrderList: function toOrderList(type) {
      //跳转至订单列表
      this.$store.commit('setCurOrderType', type);
      this.$router.push({ path: '/OrderList' });
    },
    toShopBag: function toShopBag() {
      this.$router.push({ path: '/ShopBag' });
    },
    toPackageList: function toPackageList() {
      this.$router.push({ path: '/PackageList' });
    },
    toAddrList: function toAddrList() {
      this.$router.push({ path: '/AddrList' });
    },
    toInvoiceAddrList: function toInvoiceAddrList() {
      this.$router.push({ path: '/InvoiceAddrList' });
    },
    toInvoiceList: function toInvoiceList() {
      this.$router.push({ path: '/InvoiceList' });
    },
    getPrepayInfo: function getPrepayInfo() {
      var _this = this;

      if (!this.$store.state.userInfo.user_id) {
        //先登录
        this.$router.push('/Login?backRoute=' + this.$route.path);
        return;
      }
      this.$cHttp.post('customers/prepaylog', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        page_pernum: 10,
        current_page: 1
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this.$store.commit('setSubOrderInfo', {
            cus_prepay: res.data.cus_prepay,
            so_no: '',
            so_id: '',
            so_total: 0
          });
        } else {
          //this.$toast('暂无数据')
        }
      }).catch(function (msg) {
        //this.$toast(msg);
      });
    }
  },
  components: {
    SearchBlock: __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__["a" /* default */]
  }
});

/***/ }),

/***/ "s0E0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tocheck-icon.c8d6ebf.png";

/***/ }),

/***/ "s4rC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sGqR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sYOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__ = __webpack_require__("mnFd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      keyWord: '',
      curPage: 1,
      pageSize: 10,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: true,
      listenScroll: true,
      probeType: 3,
      /*orderTypeMap: {
        topay: '待付款',
        payed: '已付款',
        tocheck: '待审核',
        checkedorder: '已审核',
        cancel: '已取消'
      }*/
      orderStatusMap: ['未审核', '审核通过', '审核通过', '已取消'],
      orderTypeMap: ['未付款', '部分付款', '全额付款']
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this._getData(true);
  },

  methods: {
    searchSub: function searchSub(keyWord) {
      this.$router.push({ path: '/GoodsList/' + keyWord });
    },
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },
    scroll: function scroll(scrollPos, maxY) {
      if (scrollPos.y > 30) {
        this.pullDownMsg = '释放刷新';
      }
      if (scrollPos.y <= maxY - 40 && this.hasMore) {
        this.pullUpMsg = '释放加载更多';
      }
    },
    scrollToEnd: function scrollToEnd() {
      if (this.hasMore) {
        this._getData();
      }
    },
    scrollToTop: function scrollToTop() {
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
    },
    toDetail: function toDetail(item) {
      this.$router.push({ path: '/OrderDetail/' + item.so_id });
    },
    payOrder: function payOrder(item) {
      var _this = this;

      //先查支付信息  再跳支付页面
      this.$cHttp.post('orders/detail', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        so_id: item.so_id
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this.$store.commit('setSubOrderInfo', {
            cus_prepay: Number(res.data.cus_prepay),
            so_no: res.data.so_no,
            so_id: res.data.so_id,
            so_total: Number(res.data.so_total),
            so_ci_method: res.data.so_ci_method
          });
          _this.$router.push({ path: '/PayInfo/' });
        } else {
          _this.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    },
    cancelOrder: function cancelOrder(item) {
      var _this2 = this;

      this.$cHttp.post('orders/cancel', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        so_id: item.so_id
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this2.$toast('取消成功');
          _this2.scrollToTop();
          _this2.$refs.listview.scrollTo(0, 0);
        } else {
          _this2.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this2.$toast(msg);
      });
    },
    setListType: function setListType(type, status) {
      this.$store.commit('setCurOrderType', type);
      this.scrollToTop();
      this.$refs.listview.scrollTo(0, 0);
    },
    _getData: function _getData(clear) {
      var _this3 = this;

      if (!this.$store.state.userInfo.user_id) {
        //先登录
        this.$router.push('/Login?backRoute=' + this.$route.path);
        return;
      }
      var type = null;
      switch (this.$store.state.curOrderType) {
        case 'all':
          type = null;
          break;
        case 'tocheck':
          type = 0;
          break;
        case 'checkedorder':
          type = 1;
          break;
        case 'cancel':
          type = 3;
          break;
      }

      this.$cHttp.post('orders/index', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        so_status: type,
        page_pernum: this.pageSize,
        current_page: this.curPage
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          if (clear) {
            _this3.data = res.data.rows;
          } else {
            _this3.data = _this3.data.concat(res.data.rows);
          }
          if (_this3.curPage + 1 > res.data.total_page) {
            _this3.hasMore = false;
            _this3.pullUpMsg = '没有更多数据了';
          } else {
            _this3.curPage++;
          }
          if (res.data.rows.length < 1) {
            _this3.$toast('暂无数据');
          }
        } else {
          _this3.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this3.$toast(msg);
      });
    }
  },
  components: {
    SearchBlock: __WEBPACK_IMPORTED_MODULE_0_basic_searchBlock_searchBlock__["a" /* default */], Scroll: __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__["a" /* default */]
  }
});

/***/ }),

/***/ "sYRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods-out-block",class:{'hasBuyBtn':_vm.hasBuyBtn}},[(!_vm.readOnly)?_c('a',{staticClass:"goods-item-mask",attrs:{"href":"javascript:void(0)"}}):_vm._e(),_vm._v(" "),(_vm.selecteable)?_c('div',{staticClass:"select-opt"},[_c('check-item',{attrs:{"itemChecked":_vm.goodsData.if_checked=='1'},on:{"clickItem":_vm.selectItem}})],1):_vm._e(),_vm._v(" "),(!_vm.isDetailItem)?[_c('div',{staticClass:"goods-avatar"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.goodsData.tagType),expression:"goodsData.tagType"}],staticClass:"goods-tag"},[_vm._v(_vm._s(_vm.goodsData.tagType))]),_vm._v(" "),_c('img',{staticClass:"goods-avatar",attrs:{"src":_vm.goodsData.img_url}})]),_vm._v(" "),_c('div',{staticClass:"goods-info-box"},[_c('h3',{staticClass:"goods-name"},[_vm._v(_vm._s(_vm.goodsData.cn_name))]),_vm._v(" "),_c('h3',{staticClass:"goods-name"},[_vm._v(_vm._s(_vm.goodsData.en_name))]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-attr"},[_vm._v("货号:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.p_code))])]),_vm._v(" "),_c('label',{staticClass:"goods-attr"},[_vm._v("CAS号:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.cas))])])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-attr"},[_vm._v("浓度级别:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.level))])])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-price"},[_c('span',{staticClass:"discont"},[_vm._v("￥"+_vm._s(_vm.goodsData.price))]),_vm._v(" "),_c('span',{staticClass:"oranginal",staticStyle:{"text-decoration":"none"}},[_vm._v("￥"+_vm._s(_vm.goodsData.amount))])])]),_vm._v(" "),_c('div',{staticClass:"numer-selector-wapper"},[(_vm.readOnly)?_c('p',[_vm._v("\n          x "+_vm._s(_vm.goodsData.num)+"\n        ")]):_c('number-selector',{attrs:{"maxNum":_vm.goodsData.maxNum?_vm.goodsData.maxNum:99999,"minNum":1,"orNum":Number(_vm.goodsData.num)},on:{"changeNum":_vm.changeNum}})],1),_vm._v(" "),(_vm.hasBuyBtn)?_c('button',{staticClass:"goods-buy-btn",on:{"click":function($event){$event.stopPropagation();_vm.putItemNum()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.goodsData.buyNum),expression:"goodsData.buyNum"}]},[_vm._v(_vm._s(_vm.goodsData.buyNum))])]):_vm._e()])]:[_c('div',{staticClass:"goods-info-box",staticStyle:{"padding-left":"0"}},[_c('h3',{staticClass:"goods-name"},[_vm._v(_vm._s(_vm.goodsData.p_cn_name))]),_vm._v(" "),_c('h3',{staticClass:"goods-name"},[_vm._v(_vm._s(_vm.goodsData.en_name))]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-attr"},[_vm._v("货号:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.p_code))])]),_vm._v(" "),_c('label',{staticClass:"goods-attr"},[_vm._v("CAS号:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.c_cas))])])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-attr"},[_vm._v("浓度级别:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.p_level))])])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-price"},[_c('span',{staticClass:"discont"},[_vm._v("￥"+_vm._s(_vm.goodsData.si_discount))]),_vm._v(" "),_c('span',{staticClass:"oranginal"},[_vm._v("￥"+_vm._s(_vm.goodsData.si_price))])])]),_vm._v(" "),_c('div',{staticClass:"numer-selector-wapper"},[(_vm.readOnly)?_c('p',[_vm._v("\n          x "+_vm._s(_vm.goodsData.si_num)+"=\n          "),_c('span',{staticClass:"discont",staticStyle:{"color":"red"}},[_vm._v("￥"+_vm._s(_vm.goodsData.si_amount))])]):_vm._e()]),_vm._v(" "),(_vm.hasBuyBtn)?_c('button',{staticClass:"goods-buy-btn",on:{"click":function($event){$event.stopPropagation();_vm.putItemNum()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.goodsData.buyNum),expression:"goodsData.buyNum"}]},[_vm._v(_vm._s(_vm.goodsData.si_num))])]):_vm._e()])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "seVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"opration-tip-bar"},[_c('p',{staticClass:"shop-bag-tip"},[_vm._v("您的购物车有"+_vm._s(_vm.$store.state.shopCount)+"款产品")]),_vm._v(" "),(_vm.data.length)?_c('div',{staticClass:"opration-btns"},[_c('button',{on:{"click":_vm.deleteItems}},[_vm._v("删除")]),_vm._v(" "),_c('button',{on:{"click":_vm.deleteAll}},[_vm._v("清空")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true},on:{"scroll":_vm.scroll,"scrollToEnd":_vm.scrollToEnd,"scrollToTop":_vm.scrollToTop}},[_c('ul',{staticClass:"query-list"},[_c('div',{staticClass:"pullDown"},[_vm._v(_vm._s(_vm.pullDownMsg))]),_vm._v(" "),(_vm.data.length<1)?_c('p',{staticClass:"empty-list"},[_vm._v("暂无数据")]):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item",on:{"click":function($event){_vm.toDetail(item)}}},[_c('order-item',{attrs:{"goodsData":item,"index":index,"selecteable":true},on:{"selectItem":_vm.selectItem,"changeItemNum":_vm.changeItemNum}})],1)}),_vm._v(" "),_c('div',{staticClass:"pullUp"},[_vm._v(_vm._s(_vm.pullUpMsg))])],2)])],1),_vm._v(" "),(_vm.data.length)?_c('div',{staticClass:"submit-bar"},[_c('p',{staticClass:"check-box all"},[_c('check-item',{attrs:{"itemChecked":_vm.selectAll},on:{"clickItem":_vm.selectAllClick}}),_c('span',{on:{"click":_vm.selectAllClick}},[_vm._v("全选")])],1),_vm._v(" "),_c('p',{staticClass:"total-price"},[_vm._v("总价:"),_c('span',[_vm._v("￥"+_vm._s(_vm.totalPrice))])]),_vm._v(" "),_c('button',{staticClass:"submit-btn",attrs:{"id":"toPay"},on:{"click":_vm.toPay}},[_vm._v("去结算(不含运费)")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sfsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_scroll_scroll__ = __webpack_require__("mnFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_basic_goodsItem_goodsItem__ = __webpack_require__("g5XB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'addrList',
  data: function data() {
    return {
      keyWord: '',
      pageSize: 1000,
      curPage: 1,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: true,
      listenScroll: true,
      probeType: 3
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this.keyWord = this.$route.params.keyword;
    this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
    this.probeType = 3;
    this.listenScroll = true;
    this.touch = {};

    this._getData(true);
  },

  methods: {
    selectAddrItem: function selectAddrItem(item) {
      if (this.$route.params.isSelect == 'true') {
        //选择地址
        this.$store.commit('setSelectedAddrData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(item));
        this.$router.back();
      }
    },
    setDefault: function setDefault(item) {
      var _this = this;

      this.$cHttp.post('cusaddrs/edit', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id
      }, item, {
        ca_if_default: '1'
      })).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this._getData();
        } else {
          _this.$toast(res.error_msg);
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    },
    newAddr: function newAddr() {
      this.$store.commit('setEidtAddrData', {});
      this.$router.push({ path: '/EditAddr?isSubSelect=' + this.$route.query.isSubSelect });
    },
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },

    /* scroll(scrollPos,maxY) {
       if (scrollPos.y > 30) {
         this.pullDownMsg='释放刷新';
       }
       if(scrollPos.y<= (maxY - 40)&&this.hasMore){
     		this.pullUpMsg='释放加载更多';
       }
     },
     scrollToEnd(){
     	if(this.hasMore){
     		this._getData();
     	}
      },
     scrollToTop(){
     	this.hasMore=true;
     	this.curPage=0;
       this._getData(true);
     },*/
    editAddr: function editAddr(item) {
      //this.$store.commit('setEidtAddrData',item);
      this.$router.push({ path: '/EditAddr?addrId=' + item.ca_id + '&isSubSelect=' + this.$route.query.isSubSelect });
    },
    deleteAddr: function deleteAddr(item) {
      var that = this;
      this.$messagebox.confirm('确定删除这条数据？', '温馨提示', { callback: function callback(type) {
          if (type == 'confirm') {
            that.$cHttp.post('cusaddrs/delete', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              ca_id: item.ca_id
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that._getData();
              } else {
                that.$toast('删除失败');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    searchSub: function searchSub(keyWord) {
      this.keyWord = keyWord;
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
      this.$refs.listview.scrollTo(0, 0);
    },
    _getData: function _getData(clear) {
      var _this2 = this;

      this.$cHttp.post('cusaddrs/index', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        page_pernum: this.pageSize,
        current_page: this.curPage
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this2.data = res.data.rows;
          if (_this2.$route.params.isSelect) {
            var selectedId = _this2.$store.state.selectedAddrData.ca_id;
            for (var i = 0; i < _this2.data.length; i++) {
              if (_this2.data[i].ca_id == selectedId) {
                _this2.data[i].isSelected = true;
              } else {
                _this2.data[i].isSelected = false;
              }
            }
          }
        } else {
          _this2.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this2.$toast(msg);
      });

      //计算数据是否为选中地址
      /*
      if(clear){
      	this.data=tempListData;
      }else{
      	this.data=this.data.concat(tempListData);
      }*/
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_2_basic_scroll_scroll__["a" /* default */], GoodsItem: __WEBPACK_IMPORTED_MODULE_3_basic_goodsItem_goodsItem__["a" /* default */], SearchBlock: __WEBPACK_IMPORTED_MODULE_4_basic_searchBlock_searchBlock__["a" /* default */]
  }
});

/***/ }),

/***/ "th6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods-out-block"},[_c('a',{staticClass:"goods-item-mask",attrs:{"href":"javascript:void(0)"}}),_vm._v(" "),(_vm.selecteable)?_c('div',{staticClass:"select-opt"},[_c('check-item',{attrs:{"itemChecked":!!_vm.goodsData.isChecked},on:{"clickItem":_vm.selectItem}})],1):_vm._e(),_vm._v(" "),_c('img',{staticClass:"goods-avatar",attrs:{"src":_vm.goodsData.img_url}}),_vm._v(" "),_c('div',{staticClass:"goods-info-box"},[_c('h3',{staticClass:"goods-name"},[_vm._v(_vm._s(_vm.goodsData.cn_name))]),_vm._v(" "),_c('h3',{staticClass:"goods-name"},[_vm._v(_vm._s(_vm.goodsData.en_name))]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-attr"},[_vm._v("项目号:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.code))])]),_vm._v(" "),_c('label',{staticClass:"goods-attr"},[_vm._v("CAS号:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.cas))])])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"goods-attr"},[_vm._v("浓度级别:"),_c('span',[_vm._v(_vm._s(_vm.goodsData.level))])])]),_vm._v(" "),_c('p',[(_vm.goodsData.if_explode)?_c('label',{staticClass:"goods-warning"},[_c('span',[_vm._v("易制爆")])]):_vm._e(),_vm._v(" "),(_vm.goodsData.if_drag)?_c('label',{staticClass:"goods-warning"},[_c('span',[_vm._v("易制毒")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tozh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDetail_vue__ = __webpack_require__("qFRv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791a1624_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDetail_vue__ = __webpack_require__("Ni3J");
function injectStyle (ssrContext) {
  __webpack_require__("ZpB4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-791a1624"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791a1624_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "txGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__ = __webpack_require__("oBeN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serverItem__ = __webpack_require__("dMDL");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register',
  data: function data() {
    return {
      registerData: {
        cus_email: '',
        cus_password: '',
        cus_re_password: '',
        cus_name: '',
        cus_mobile: '',
        cus_phone: '',
        cus_fax: '',
        ca_province: '',
        ca_city: '',
        ca_county: '',
        ca_street: '',
        ci_type: 1,
        ci_title: '',
        ci_vatno: '',
        ci_bank: '',
        ci_bknum: '',
        ci_addr: '',
        ci_phone: ''
      },
      username: '',
      checkcode: '',
      isAgree: false,
      showServerItems: false,
      checkRules: [{
        key: 'cus_email',
        name: '输入电子邮箱地址',
        formType: 'email',
        required: true,
        message: '电子邮箱地址格式不正确，且不要有空格符'
      }, {
        key: 'cus_password',
        name: '输入密码',
        required: true,
        formType: 'equal',
        eqItem: 'cus_re_password',
        message: '两次密码输入不一致'
      }, {
        key: 'cus_re_password',
        name: '重新输入密码',
        required: true,
        formType: 'equal',
        eqItem: 'cus_password',
        message: '两次密码输入不一致'
      }, {
        key: 'cus_name',
        name: '输入姓名',
        required: true
      }, {
        key: 'cus_mobile',
        name: '输入手机号码',
        required: true,
        formType: 'mobile',
        message: '请输入正确的手机号'
      }, {
        key: 'ca_province,ca_city,ca_county',
        name: '选择城市',
        required: true
      }, {
        key: 'ca_street',
        name: '输入街道地址',
        required: true
      }, {
        key: 'ci_title',
        name: '输入开票抬头',
        required: true
      }, {
        key: 'ci_vatno',
        name: '输入税号',
        required: true
      }, {
        key: 'ci_bank',
        name: '输入开户行',
        required: true
      }, {
        key: 'ci_bknum',
        name: '输入银行账号',
        required: true
      }, {
        key: 'ci_addr',
        name: '输入开票地址',
        required: true
      }, {
        key: 'ci_phone',
        name: '输入开票电话',
        required: true
      }]
    };
  },
  mounted: function mounted() {
    //获取焦点时移到页面可见区域
    $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
      var dom = e.target;
      setTimeout(function () {
        dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
      }, 200);
    });
  },

  methods: {
    showAddr: function showAddr(type, parent) {
      this.$refs.addrSelector.showAddr(type, parent);
    },
    endSelectAddr: function endSelectAddr(vals) {
      console.log(vals);
      this.registerData.ca_province = vals[0];
      this.registerData.ca_city = vals[1];
      this.registerData.ca_county = vals[2];
    },
    setInvoiceType: function setInvoiceType(type) {
      if (this.invoiceType != type) {
        this.registerData.ci_type = type;
        this.$nextTick(function () {
          //获取焦点时移到页面可见区域
          $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
            var dom = e.target;
            setTimeout(function () {
              dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
            }, 200);
          });
        });
      }
    },
    registerSub: function registerSub() {
      var _this = this;

      if (this.checkData()) {
        if (!this.isAgree) {
          this.$toast('请勾选同意本应用《服务条款》');
          return;
        }
        var _sendData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.registerData));
        delete _sendData.cus_re_password;
        if (this.registerData.type == 1) {
          delete _sendData.ci_bank;
          delete _sendData.ci_bknum;
          delete _sendData.ci_addr;
          delete _sendData.ci_phone;
        }
        this.$cHttp.post('customers/sign', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          partner: this.$systemConfig.partner,
          apikey: this.$systemConfig.apikey
        }, this.registerData)).then(function (res) {
          console.log(res);
          if (res.status == 1) {
            _this.$toast('注册成功！');
            _this.$router.replace('/login');
          } else {
            _this.$toast(res.error_msg);
          }
        }).catch(function (msg) {
          _this.$toast(msg);
        });
      }
    },
    agreeServer: function agreeServer() {
      this.isAgree = !this.isAgree;
    },
    toServer: function toServer() {
      this.showServerItems = true;
    },
    closeServer: function closeServer() {
      this.showServerItems = false;
    },
    checkData: function checkData() {
      //表单验证
      var checkLength = 0;
      if (this.registerData.ci_type == 1) {
        checkLength = 9;
      } else {
        checkLength = 13;
      }
      for (var i = 0; i < checkLength; i++) {
        var keyArr = this.checkRules[i].key.split(',');
        for (var j = 0; j < keyArr.length; j++) {
          //非空检验
          if (this.checkRules[i].required && !this.registerData[keyArr[j]]) {
            this.$toast('请' + this.checkRules[i].name);
            return false;
          } else {
            //格式检验
            if (this.checkRules[i].formType) {
              var _value = this.registerData[keyArr[j]];
              switch (this.checkRules[i].formType) {
                case 'mobile':
                  if (!/^1[34578]\d{9}$/.test(_value)) {
                    this.$toast(this.checkRules[i].message);
                    return false;
                  }
                  break;
                case 'email':
                  if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(_value)) {
                    this.$toast(this.checkRules[i].message);
                    return false;
                  }
                  break;
                case 'equal':
                  var _eqValue = this.registerData[this.checkRules[i].eqItem];
                  if (!_eqValue || _eqValue !== _value) {
                    this.$toast(this.checkRules[i].message);
                    return false;
                  }
                  break;
              }
            }
          }
        }
      }
      return true;
    }
  },
  components: {
    AddrSelector: __WEBPACK_IMPORTED_MODULE_2_basic_addrSelector_addrSelector__["a" /* default */], ServerItem: __WEBPACK_IMPORTED_MODULE_3__serverItem__["a" /* default */]
  }
});

/***/ }),

/***/ "uJ0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vSvE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vlaI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w5BE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_orderItem_orderItem__ = __webpack_require__("PsGa");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'submitOrder',
  data: function data() {
    return {
      needInvoice: false,
      orderData: {
        goodsList: [],
        defaultAddr: {},
        defaultInvoiceAddr: {},
        invoiceInfo: {},
        priceData: {
          freight: 0.00,
          dryIce: 0.00
        },
        totalPrice: 0
      },
      buyNum: '',
      extralInfo: ''
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getOrderInfo();
    this.extralInfo = this.$store.state.userInfo.cus_send_note;
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }

    //获取焦点时移到页面可见区域
    $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus', function (e) {
      var dom = e.target;
      setTimeout(function () {
        dom.scrollIntoView(true);dom.scrollIntoViewIfNeeded();
      }, 200);
    });
  },

  methods: {
    selectAddr: function selectAddr() {
      this.$router.push({ path: '/AddrList/' + true + '?isSubSelect=1' });
    },
    selectInvoiceAddr: function selectInvoiceAddr() {
      this.$router.push({ path: '/InvoiceAddrList/' + true + '?isSubSelect=1' });
    },
    needInvoiceSwitch: function needInvoiceSwitch(type) {
      this.needInvoice = type;
    },
    selectInvoice: function selectInvoice() {
      this.$router.push({ path: '/InvoiceList/' + true });
    },
    toPay: function toPay() {
      var _this = this;

      //获取订单信息
      this.$cHttp.post('shopcart/confirm', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        ca_id: this.$store.state.selectedAddrData.ca_id,
        cia_id: this.$store.state.selectedInvoiceAddrData.cia_id,
        ci_id: this.$store.state.selectedInvoiceData.ci_id,
        so_ci_method: this.needInvoice ? '1' : '0',
        so_note: this.extralInfo,
        cus_invoice_method: this.$store.state.userInfo.cus_invoice_method,
        cus_free_express: this.$store.state.userInfo.cus_free_express,
        cus_send_note: this.$store.state.userInfo.cus_send_note
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this.$toast('订单提交成功!');
          _this.$store.commit('setSubOrderInfo', {
            cus_prepay: Number(res.data.cus_prepay),
            so_no: res.data.so_no,
            so_id: res.data.so_id,
            so_total: Number(res.data.so_total),
            so_ci_method: res.data.so_ci_method
          });
          console.log(_this.$store.state.subOrderInfo);
          _this.$store.commit('setShopCount', res.total_num);
          _this.$router.push({ path: '/PayInfo/' });
        } else {
          _this.$toast(res.error_msg);
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
      //this.$router.push({path:'/payInfo'})
    },
    toDetail: function toDetail(item) {
      // this.$router.push({path:'/GoodsDetail/'+item.id})
    },
    getOrderInfo: function getOrderInfo() {
      var _this2 = this;

      //获取订单信息
      this.$cHttp.post('shopcart/checkout', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        cus_free_express: this.$store.state.userInfo.cus_free_express
      }).then(function (res) {
        if (res.status && res.status == 1) {
          console.log(res);
          _this2.orderData.goodsList = res.data.items;
          _this2.orderData.defaultAddr = {
            ca_city: res.data.ca_city,
            ca_county: res.data.ca_county,
            ca_id: res.data.ca_id,
            ca_if_default: res.data.ca_if_default,
            ca_mobile: res.data.ca_mobile,
            ca_name: res.data.ca_name,
            ca_phone: res.data.ca_phone,
            ca_province: res.data.ca_province,
            ca_street: res.data.ca_street
          };
          _this2.orderData.defaultInvoiceAddr = {
            cia_city: res.data.cia_city,
            cia_county: res.data.cia_county,
            cia_id: res.data.cia_id,
            cia_if_default: res.data.cia_if_default,
            cia_mobile: res.data.cia_mobile,
            cia_name: res.data.cia_name,
            cia_phone: res.data.cia_phone,
            cia_province: res.data.cia_province,
            cia_street: res.data.cia_street
          };
          _this2.orderData.invoiceInfo = {
            ci_addr: res.data.ci_addr,
            ci_bank: res.data.ci_bank,
            ci_bknum: res.data.ci_bknum,
            ci_id: res.data.ci_id,
            ci_if_default: res.data.ci_if_default,
            ci_phone: res.data.ci_phone,
            ci_title: res.data.ci_title,
            ci_type: res.data.ci_type,
            ci_vatno: res.data.ci_vatno
          };
          if (_this2.orderData.invoiceInfo.ci_id) {
            _this2.needInvoice = true;
          }
          _this2.orderData.totalPrice = res.data.total;
          _this2.storeAddrInfo();
          _this2.getFreight();
        } else {
          _this2.$toast(res.error_msg);
        }
      }).catch(function (msg) {
        _this2.$toast(msg);
      });
    },
    getFreight: function getFreight() {
      var _this3 = this;

      //获取运费
      this.$cHttp.post('shopcart/express', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        ca_id: this.orderData.defaultInvoiceAddr.cia_id,
        cus_free_express: this.$store.state.userInfo.cus_free_express
      }).then(function (res) {
        if (res.status && res.status == 1) {
          _this3.orderData.priceData.freight = res.express;
        } else {
          _this3.$toast(res.error_msg);
        }
      }).catch(function (msg) {
        _this3.$toast(msg);
      });
    },
    storeAddrInfo: function storeAddrInfo() {
      //将地址存起来
      if (this.$store.state.selectedAddrData.ca_id || this.$store.state.selectedAddrData.ca_id == 0 && this.$store.state.selectedAddrData.ca_id != '') {
        //地址已存在不需赋值
      } else {
        this.$store.commit('setSelectedAddrData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.orderData.defaultAddr));
      }
      //将收票地址存起来
      if (this.$store.state.selectedInvoiceAddrData.cia_id || this.$store.state.selectedInvoiceAddrData.cia_id == 0 && this.$store.state.selectedInvoiceAddrData.cia_id != '') {
        //地址已存在不需赋值
      } else {
        this.$store.commit('setSelectedInvoiceAddrData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.orderData.defaultInvoiceAddr));
      }
      //将发票存起来
      if (this.$store.state.selectedInvoiceData.ci_id || this.$store.state.selectedInvoiceData.ci_id == 0 && this.$store.state.selectedInvoiceData.ci_id != '') {
        //发票已存在不需赋值
      } else {
        this.$store.commit('setSelectedInvoiceData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.orderData.invoiceInfo));
      }
    }
  },
  components: {
    OrderItem: __WEBPACK_IMPORTED_MODULE_1_basic_orderItem_orderItem__["a" /* default */]
  }
});

/***/ }),

/***/ "wdrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('form',{staticClass:"addr-form",attrs:{"name":"addrForm","action":"javascript:void(0)"}},[_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"姓名","placeholder":"请输入姓名"},model:{value:(_vm.addrInfo.ca_name),callback:function ($$v) {_vm.addrInfo.ca_name=$$v},expression:"addrInfo.ca_name"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent required",attrs:{"label":"手机号","placeholder":"请输入手机号","type":"number"},model:{value:(_vm.addrInfo.ca_mobile),callback:function ($$v) {_vm.addrInfo.ca_mobile=$$v},expression:"addrInfo.ca_mobile"}}),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"联系电话","placeholder":"请输入联系电话","type":"number"},model:{value:(_vm.addrInfo.ca_phone),callback:function ($$v) {_vm.addrInfo.ca_phone=$$v},expression:"addrInfo.ca_phone"}}),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showAddr('province')}}},[_c('mt-field',{staticClass:"required",attrs:{"label":"省","placeholder":"请选择省","readonly":true,"disableClear":true},model:{value:(_vm.addrInfo.ca_province),callback:function ($$v) {_vm.addrInfo.ca_province=$$v},expression:"addrInfo.ca_province"}})],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showAddr('city',_vm.addrInfo.ca_province)}}},[_c('mt-field',{staticClass:"required",attrs:{"label":"市","placeholder":"请选择市","readonly":true,"disableClear":true},model:{value:(_vm.addrInfo.ca_city),callback:function ($$v) {_vm.addrInfo.ca_city=$$v},expression:"addrInfo.ca_city"}})],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showAddr('county',_vm.addrInfo.ca_city)}}},[_c('mt-field',{staticClass:"required",attrs:{"label":"区/县","placeholder":"请选择区/县","readonly":true,"disableClear":true},model:{value:(_vm.addrInfo.ca_county),callback:function ($$v) {_vm.addrInfo.ca_county=$$v},expression:"addrInfo.ca_county"}})],1),_vm._v(" "),_c('mt-field',{staticClass:"inputcontent",attrs:{"label":"详细地址","placeholder":"请输入详细地址","type":"textarea"},model:{value:(_vm.addrInfo.ca_street),callback:function ($$v) {_vm.addrInfo.ca_street=$$v},expression:"addrInfo.ca_street"}}),_vm._v(" "),_c('p',{staticClass:"set-default-group",on:{"click":_vm.setDefault}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':_vm.addrInfo.ca_if_default==1}}),_vm._v("设为默认地址")]),_vm._v(" "),_c('div',{staticClass:"opr-group"},[_c('mt-button',{attrs:{"size":"large","plain":""},on:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"btn-div"}),_vm._v(" "),(!_vm.isNew)?_c('mt-button',{attrs:{"size":"large","type":"danger","plain":""},on:{"click":_vm.deleteAddr}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-div"}),_vm._v(" "),_c('mt-button',{attrs:{"size":"large","type":"danger"},on:{"click":_vm.saveAddr}},[_vm._v("保存")])],1)],1),_vm._v(" "),_c('addr-selector',{ref:"addrSelector",attrs:{"curProvince":_vm.addrInfo.ca_province,"curCity":_vm.addrInfo.ca_city,"curCounty":_vm.addrInfo.ca_county},on:{"endSelectAddr":_vm.endSelectAddr}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wlhD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editInvoice_vue__ = __webpack_require__("72kJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe8255a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editInvoice_vue__ = __webpack_require__("MbcA");
function injectStyle (ssrContext) {
  __webpack_require__("0nQX")
  __webpack_require__("nybC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe8255a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe8255a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_basic_layout_footerBar__ = __webpack_require__("JY51");
//
//
//
//
//
//
//

//  import { Toast } from 'mint-ui';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  components: {
    FooterBar: __WEBPACK_IMPORTED_MODULE_0_basic_layout_footerBar__["a" /* default */]
  },
  beforeRouteUpdate: function beforeRouteUpdate() {
    console.log(1111);
  }
});

/***/ }),

/***/ "xODf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"search-group-wapper"},[_c('search-block',{ref:"searchBlock",on:{"searchSub":_vm.searchSub}})],1),_vm._v(" "),_c('div',{staticClass:"list-wapper"},[_c('scroll',{ref:"listview",staticClass:"listview",attrs:{"listen-scroll":_vm.listenScroll,"probe-type":_vm.probeType,"data":_vm.data,"pullup":true}},[_c('ul',{staticClass:"query-list"},[_vm._l((_vm.data),function(item,index){return _c('li',{ref:"listGroup",refInFor:true,staticClass:"list-item",on:{"click":function($event){_vm.selectInvoiceItem(item)}}},[(_vm.$route.params.isSelect=='true')?_c('i',{staticClass:"mint-checkbox-core",class:{'checked':item.isSelected}}):_vm._e(),_vm._v(" "),_c('div',[_c('i',{staticClass:"invoice-type-icon"},[_vm._v(_vm._s(['','普','专'][item.ci_type]))]),_vm._v(" "),_c('h3',{staticClass:"invoice-info-item"},[_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("抬头：")]),_vm._v(_vm._s(item.ci_title))]),_vm._v(" "),_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("税号：")]),_vm._v(_vm._s(item.ci_vatno))])]),_vm._v(" "),(item.ci_type=='2')?_c('h3',{staticClass:"invoice-info-item"},[_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("银行：")]),_vm._v(_vm._s(item.ci_bank))]),_vm._v(" "),_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("账号：")]),_vm._v(_vm._s(item.ci_bknum))])]):_vm._e(),_vm._v(" "),(item.ci_type=='2')?_c('h3',{staticClass:"invoice-info-item"},[_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("地址：")]),_vm._v(_vm._s(item.ci_addr))]),_vm._v(" "),_c('label',{staticClass:"value"},[_c('span',{staticClass:"name"},[_vm._v("电话：")]),_vm._v(_vm._s(item.ci_phone))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"opr-bar"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.params.isSelect!='true'),expression:"$route.params.isSelect!='true'"}],staticClass:"set-default-group",class:{'active':item.ci_if_default=='1'},on:{"click":function($event){$event.stopPropagation();_vm.setDefault(item)}}},[_c('i',{staticClass:"mint-checkbox-core",class:{'checked':item.ci_if_default=='1'}}),_vm._v("\n\t\t        \t\t\t"+_vm._s(item.ci_if_default=='1'?'默认值':'设为默认值'))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.params.isSelect=='true'),expression:"$route.params.isSelect=='true'"}],staticClass:"set-default-group",class:{'active':item.ci_if_default=='1'}},[_vm._v("\n\t\t        \t\t\t"+_vm._s(item.ci_if_default=='1'?'默认值':'')+"\n\t\t        \t\t")]),_vm._v(" "),_c('p',{staticClass:"opr-btns"},[_c('a',{staticClass:"opr-btn edit",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.stopPropagation();_vm.editInvoice(item)}}}),_vm._v(" "),_c('a',{staticClass:"opr-btn delete",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.stopPropagation();_vm.deleteInvoice(item)}}})])])])])}),_vm._v(" "),_c('div',{staticClass:"add-group",staticStyle:{"padding":".2rem"}},[_c('mt-button',{attrs:{"size":"large","type":"danger"},on:{"click":_vm.newInvoice}},[_vm._v("新增")])],1)],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xeyQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pakageInfo.so_no)?_c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"order-status"},[_c('label',[_vm._v("配货单号："+_vm._s(_vm.pakageInfo.dp_id))])]),_vm._v(" "),_c('div',{staticClass:"order-status"},[_c('label',[_vm._v("订单号："+_vm._s(_vm.pakageInfo.so_no))])]),_vm._v(" "),_c('div',{staticClass:"order-status"},[_c('label',[_vm._v("快递公司："+_vm._s(_vm.pakageInfo.dp_express_com))])]),_vm._v(" "),_c('div',{staticClass:"order-status"},[_c('label',[_vm._v("快递单号："+_vm._s(_vm.pakageInfo.dp_express_no))])]),_vm._v(" "),_c('div',{staticClass:"order-time"},[_c('label',[_vm._v("发货日期："+_vm._s(_vm.pakageInfo.dp_sendtime))])]),_vm._v(" "),_c('div',{staticClass:"order-time"},[_c('label',[_vm._v("订单日期："+_vm._s(_vm.pakageInfo.so_ctime))])]),_vm._v(" "),_c('div',{staticClass:"order-addr"},[_c('h3',{staticClass:"block-title"},[_vm._v("收货地址")]),_vm._v(" "),_c('h3',{staticClass:"addr-user"},[_c('label',{staticClass:"name"},[_vm._v(_vm._s(_vm.pakageInfo.so_ca_name))]),_c('span',{staticClass:"telNum"},[_vm._v(_vm._s(_vm.pakageInfo.so_ca_mobile))]),_c('span',{staticClass:"telNum"},[_vm._v("  "+_vm._s(_vm.pakageInfo.so_ca_phone))])]),_vm._v(" "),_c('p',{staticClass:"addr-area"},[_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.pakageInfo.so_ca_province))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.pakageInfo.so_ca_city))]),_vm._v(" "),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.pakageInfo.so_ca_county))]),_c('span',{staticClass:"area"},[_vm._v(_vm._s(_vm.pakageInfo.so_ca_street))])])]),_vm._v(" "),_c('div',{staticClass:"goods-list-box"},[_c('h3',{staticClass:"block-title"},[_vm._v("货物信息")]),_vm._v(" "),(_vm.pakageInfo.items&&_vm.pakageInfo.items.length)?_c('ul',{staticClass:"goods-list"},_vm._l((_vm.pakageInfo.items),function(item,index){return _c('li',{staticClass:"goods-list-item"},[_c('div',{staticClass:"goods-item-conetn-left"},[_c('p',[_vm._v("货号："+_vm._s(item.p_code))]),_vm._v(" "),_c('p',[_vm._v("产品名称："+_vm._s(item.p_cn_name))]),_vm._v(" "),_c('p',[_vm._v("浓度级别："+_vm._s(item.p_level))])]),_vm._v(" "),_c('p',[_vm._v("x"+_vm._s(item.dpd_num))])])})):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xuVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-outbox"},[_c('div',{staticClass:"prepay-info-box"},[_c('div',{staticClass:"prepay-body"},[_c('div',{staticClass:"prepay-title"},[_vm._v("\n        金额\n      ")]),_vm._v(" "),_c('div',{staticClass:"prepay-money"},[_vm._v("￥"+_vm._s(_vm.$store.state.subOrderInfo.so_total))]),_vm._v(" "),_c('p',{staticClass:"order-num"},[_vm._v("订单号:"+_vm._s(_vm.$store.state.subOrderInfo.so_no))])])]),_vm._v(" "),(_vm.$store.state.userInfo.cus_chk_type!='1'&&_vm.$store.state.userInfo.cus_if_pre=='1')?_c('div',{staticClass:"order-price-box"},[_c('label',[_vm._v("预付款金额:")]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(_vm.$store.state.subOrderInfo.cus_prepay))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"opr-btn-group"},[(_vm.$store.state.userInfo.cus_chk_type!='1'&&_vm.$store.state.userInfo.cus_if_pre!='1'&&_vm.$store.state.subOrderInfo.so_ci_method!='3')?_c('mt-button',{staticClass:"green",attrs:{"size":"large"},on:{"click":function($event){_vm.selectPayType('wechat')}}},[_vm._v("微信支付")]):_vm._e(),_vm._v(" "),(_vm.$store.state.userInfo.cus_chk_type!='1'&&_vm.$store.state.userInfo.cus_if_pre=='1')?_c('mt-button',{staticClass:"blue",attrs:{"size":"large","disabled":!_vm.canPrePay},on:{"click":function($event){_vm.selectPayType('prepay')}}},[_vm._v(_vm._s(_vm.canPrePay?'预付支付':'余额不足'))]):_vm._e(),_vm._v(" "),_c('mt-button',{staticClass:"yellow",attrs:{"size":"large"},on:{"click":function($event){_vm.selectPayType('offline')}}},[_vm._v("线下支付")])],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-offline-tips"},[_c('p',[_vm._v("公司名称：上海易恩化学技术有限公司"),_c('br'),_vm._v("\n      账号：3100 6930 9018 8000 03232"),_c('br'),_vm._v("\n      开户行：交通银行上海南桥支行"),_c('br'),_vm._v("\n      注：汇款时敬请在汇款用途栏或附言栏中填入您的订单号，以便我们核对并确保您的订单能够及时发货。\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y+mr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y7ZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-outBox",on:{"click":function($event){$event.stopPropagation();_vm.clickItem($event)}}},[_c('div',{staticClass:"check-box",class:{'active':_vm.itemChecked}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yiBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var curHostA = window.location.href
var curHost = window.location.host
var pre = curHostA.split('://')[0]
var basicUrl = pre + '://' + curHost
var wxUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc002bde145623f26&redirect_uri=' + encodeURIComponent('http://www.rhawn.cn/author/index') + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
if (window.location.href.indexOf('localhost') > -1) {
	//测试地址
	var basicParam = {
		basicUrl: 'https://www.rhawn.cn/api/',
		partner:'wap',
		apikey:'2a7f1044c9abad10b6d39aa85c37197b',
		ERROROK: 1,
		wxUrl: wxUrl
	};
} else if (window.location.href.indexOf('www.rhawn.cn') > -1){
		//正式地址
		var basicParam = {
			basicUrl: 'https://www.rhawn.cn/api/',
			partner:'wap',
			apikey:'2a7f1044c9abad10b6d39aa85c37197b',
			ERROROK: 1,
			wxUrl: wxUrl
		};
	} else {
		//测试地址
		var basicParam = {
			basicUrl: 'https://www.rhawn.cn/api/',
			partner:'wap',
			apikey:'2a7f1044c9abad10b6d39aa85c37197b',
			ERROROK: 1,
			wxUrl: wxUrl
		};
	}

	/* harmony default export */ __webpack_exports__["a"] = (basicParam);

/***/ }),

/***/ "z4yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__ = __webpack_require__("zaHw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bea8af08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__ = __webpack_require__("xODf");
function injectStyle (ssrContext) {
  __webpack_require__("gIQV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bea8af08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bea8af08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zAZr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_packageList_vue__ = __webpack_require__("nf/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7704db2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_packageList_vue__ = __webpack_require__("IJHB");
function injectStyle (ssrContext) {
  __webpack_require__("SDj6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7704db2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_packageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7704db2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_packageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zCQ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zaHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__ = __webpack_require__("mnFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_basic_goodsItem_goodsItem__ = __webpack_require__("g5XB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_basic_searchBlock_searchBlock__ = __webpack_require__("ZPNk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoiceList',
  data: function data() {
    return {
      keyWord: '',
      curPage: 1,
      pageSize: 10,
      data: [],
      pullDownMsg: "下拉刷新",
      pullUpMsg: "上拉加载",
      maxY: 0,
      hasMore: true,
      listenScroll: true,
      probeType: 3
    };
  },
  mounted: function mounted() {
    if (this.$route.meta && this.$route.meta.pageBelong) {
      this.$store.commit('setPageBelong', this.$route.meta.pageBelong);
    }
    this.keyWord = this.$route.params.keyword;
    this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
    this.probeType = 3;
    this.listenScroll = true;
    this.touch = {};

    this._getData(true);
  },

  methods: {
    selectInvoiceItem: function selectInvoiceItem(item) {
      if (this.$route.params.isSelect == 'true') {
        //选择地址
        this.$store.commit('setSelectedInvoiceData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item));
        console.log('发票', this.$store.state.selectedInvoiceData);
        this.$router.back();
      }
    },
    setDefault: function setDefault(item) {
      for (var i = 0; i < this.data.length; i++) {
        this.data[i].isDefault = false;
      }
      item.isDefault = !item.isDefault;
    },
    newInvoice: function newInvoice() {
      this.$store.commit('setEidtInvoiceData', {});
      this.$router.push({ path: '/EditInvoice?isSubSelect=' + this.$route.query.isSubSelect });
    },
    refresh: function refresh() {
      this.$refs.listview.refresh();
    },

    /* scroll(scrollPos,maxY) {
       if (scrollPos.y > 30) {
         this.pullDownMsg='释放刷新';
       }
       if(scrollPos.y<= (maxY - 40)&&this.hasMore){
     		this.pullUpMsg='释放加载更多';
       }
     },
     scrollToEnd(){
     	if(this.hasMore){
     		this._getData();
     	}
      },
     scrollToTop(){
     	this.hasMore=true;
     	this.curPage=0;
       this._getData(true);
     },*/
    editInvoice: function editInvoice(item) {
      this.$router.push({ path: '/EditInvoice?invoiceId=' + item.ci_id + '&isSubSelect=' + this.$route.query.isSubSelect });
    },
    deleteInvoice: function deleteInvoice(item) {
      var that = this;
      this.$messagebox.confirm('确定删除这条数据？', '温馨提示', { callback: function callback(type) {
          if (type == 'confirm') {
            that.$cHttp.post('cusinvoice/delete', {
              partner: that.$systemConfig.partner,
              apikey: that.$systemConfig.apikey,
              ci_id: item.ci_id
            }).then(function (res) {
              console.log(res);
              if (res.status && res.status == 1) {
                that._getData();
              } else {
                that.$toast('删除失败');
              }
            }).catch(function (msg) {
              that.$toast(msg);
            });
          }
        } });
    },
    searchSub: function searchSub(keyWord) {
      this.keyWord = keyWord;
      this.hasMore = true;
      this.curPage = 1;
      this._getData(true);
      this.$refs.listview.scrollTo(0, 0);
    },
    _getData: function _getData(clear) {
      var _this = this;

      this.$cHttp.post('cusinvoice/index', {
        partner: this.$systemConfig.partner,
        apikey: this.$systemConfig.apikey,
        user_id: this.$store.state.userInfo.user_id,
        page_pernum: this.pageSize,
        current_page: this.curPage
      }).then(function (res) {
        console.log(res);
        if (res.status && res.status == 1) {
          _this.data = res.data.rows;
          if (_this.$route.params.isSelect) {
            var selectedId = _this.$store.state.selectedInvoiceData.ci_id;
            for (var i = 0; i < _this.data.length; i++) {
              if (_this.data[i].ci_id == selectedId) {
                _this.data[i].isSelected = true;
              } else {
                _this.data[i].isSelected = false;
              }
            }
          }
        } else {
          _this.$toast('暂无数据');
        }
      }).catch(function (msg) {
        _this.$toast(msg);
      });
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_1_basic_scroll_scroll__["a" /* default */], GoodsItem: __WEBPACK_IMPORTED_MODULE_2_basic_goodsItem_goodsItem__["a" /* default */], SearchBlock: __WEBPACK_IMPORTED_MODULE_3_basic_searchBlock_searchBlock__["a" /* default */]
  }
});

/***/ }),

/***/ "zoya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userCenter_vue__ = __webpack_require__("rNgS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67614264_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userCenter_vue__ = __webpack_require__("Tpo3");
function injectStyle (ssrContext) {
  __webpack_require__("vlaI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67614264"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userCenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67614264_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userCenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.5b5cd67587fd960cf660.js